// Español de México — el idioma de casa.
//
// Este archivo NO se parte: viaja dentro del archivo principal, siempre. Casi
// todo el tráfico es de México, y si el español llegara en un segundo viaje de
// red el visitante vería la pantalla vacía (o peor, las claves crudas tipo
// 'home.heroBody') mientras baja. Inglés y portugués sí van aparte: ver
// ./en-US.js, ./pt-BR.js y el cargador ./loader.js.

const esMX = {
  'header.coa': 'Pureza verificada por HPLC',
  'header.shipping': 'Envío nacional en México · Cotizado por separado',
  'header.ruo': 'Solo para uso en investigación (RUO)',
  'header.brandTagline': 'Péptidos de investigación',
  'header.searchShort': 'Buscar péptidos...',
  'header.searchLong': 'Buscar BPC-157, Ipamorelin, TB-500...',
  'header.allCatalog': 'Todo El Catálogo',
  'header.all': 'Todo',
  'header.account': 'Mi Cuenta',
  'header.difusion': 'Difusión',
  'header.admin': 'Panel Admin',
  'header.logout': 'Cerrar Sesión',
  'header.tutorials': 'Tutoriales',
  'admin.ficha.open': 'Ver ficha',
  'admin.ficha.inviteOk': 'Invitación aceptada',
  'viewAs.button': 'Ver como',
  'calc.orientativeNote': '⚠ Dosis orientativa: sin literatura firme en humanos. Tomada de estudios preclínicos y escalada de forma conservadora. Solo para investigación (RUO).',
  'viewAs.banner': 'Estás viendo el sitio como {{name}} — solo lectura, no puedes hacer cambios.',
  'viewAs.exit': 'Salir del modo ver como',
  'news.delete': 'Borrar aviso',
  'whatsapp.prefill': 'Hola, me interesa información sobre sus productos.',
  'whatsapp.aria': 'Escríbenos por WhatsApp',
  'news.clearAll': 'Borrar todas',
  'account.orderDiscount': 'Descuento ({{pct}}%)',
  'distributor.bestSellers': 'Tus productos más vendidos',
  'distributor.bestSellersSub': 'Lo que más se mueve en tu red. Úsalo para saber qué recomendar.',
  'account.orderPoints': 'Puntos usados ({{points}})',
  'news.deleteError': 'No se pudo borrar',
  'admin.ficha.invitePending': 'Invitación pendiente',
  'admin.ficha.notes': 'Notas del admin (solo las ves tú)',
  'admin.ficha.saveNotes': 'Guardar notas',
  'admin.ficha.notesSaved': 'Notas guardadas',
  'admin.ficha.loadError': 'No se pudo cargar la ficha',
  'admin.ficha.couponSent': 'Cupón {{code}} enviado al cliente',
  'admin.ficha.pointsSent': 'Puntos regalados. Nuevo saldo: {{balance}}',
  'admin.ficha.paid': 'Pagado',
  'admin.ficha.paidOrders': 'Pedidos pagados',
  'admin.ficha.points': 'Puntos',
  'admin.ficha.coupons': 'Cupones enviados',
  'admin.ficha.couponUsed': 'Usado',
  'admin.ficha.couponActive': 'Activo',
  'admin.ficha.couponExpired': 'Vencido',
  'admin.ficha.sendCoupon': 'Mandar cupón de descuento',
  'admin.ficha.days': 'días de vigencia',
  'admin.ficha.noteOptional': 'Mensaje para el cliente (opcional)',
  'admin.ficha.sendCouponBtn': 'Enviar cupón',
  'admin.ficha.giftPoints': 'Regalar puntos de lealtad',
  'admin.ficha.giftPointsBtn': 'Regalar puntos',
  'admin.ficha.codes': 'Códigos de descuento',
  'admin.ficha.subs': 'Sub-distribuidores',
  'admin.ficha.clients': 'Clientes',
  'admin.ficha.clientsShort': 'clientes',
  'admin.ficha.ordersShort': 'pedidos',
  'admin.ficha.recentSales': 'Ventas recientes',
  'tutorials.title': 'Tutoriales',
  'tutorials.subtitle': 'Videos cortos y guías escritas para sacarle todo el provecho a tu panel.',
  'tutorials.videos': 'Videos',
  'tutorials.moreSoon': 'Más videos en camino…',
  'tutorials.membersTitle': 'Los tutoriales son exclusivos para miembros',
  'tutorials.membersBody': 'Inicia sesión con tu cuenta para ver los videos y las guías de tu panel. Crear tu cuenta es gratis.',
  'tutorials.membersCta': 'Iniciar sesión',
  'tutorials.distGuide': 'Guía Del Panel De Distribuidor',
  'tutorials.distGuideSub': 'Qué hace cada sección de tu panel, explicado a detalle.',
  'tutorials.clientGuide': 'Guía de tu cuenta',
  'tutorials.clientGuideSub': 'Todo lo que puedes hacer desde tu cuenta de cliente.',
  'tutorials.prospect.title': '¿Quieres Ser Distribuidor?',
  'tutorials.prospect.body': 'Conoce el programa en minuto y medio: tu panel, tus comisiones y tus herramientas. Luego, agenda una llamada con nuestro equipo.',
  'tutorials.prospect.cta': 'Escríbenos por WhatsApp',
  'tutorials.prospect.wa': 'Hola, me interesa ser distribuidor de Exygen Labs. Quiero agendar una llamada.',
  'learn.video.title': 'Míralo En Video',
  'learn.video.sub': 'Poco más de cuatro minutos con todo lo que dice esta página.',
  'discount.launchBanner': 'Precio de lanzamiento: 10% de descuento en tu primer pedido',
  'discount.volumeTitle': 'Descuento por volumen automático',
  'discount.appliedInCart': 'Se aplica solo en el carrito, sin código.',
  'nav.home': 'Inicio',
  'nav.resources': 'Recursos y herramientas',
  'nav.contactExpert': 'Contactar experto',
  'product.card.presentations': 'presentaciones',
  'checkout.viewDetail': 'Ver detalle',
  'checkout.hideDetail': 'Ocultar',
  'bac.title': '¿¿Necesitas agua bacteriostática?',
  'bac.body': 'Tus péptidos vienen liofilizados (en polvo) y se reconstituyen con agua bacteriostatica antes de usarse. Puedes agregarla aquí o continuar si ya la tienes.',
  'bac.note': 'Agregarla es opcional, solo es un recordatorio para que no te falte al reconstituir.',
  'bac.smart': 'Llevas {{vials}} vial(es) para reconstituir: estimamos ~{{ml}} mL de agua bacteriostatica. Sugerencia: {{qty}} vial(es) de {{size}}.',
  'bac.add': 'Agregar {{qty}} x {{size}} ({{price}})',
  'bac.skip': 'Continuar sin agregarla',
  'bac.back': 'Volver al carrito',

  'distributor.filter.allTime': 'Todo el tiempo',
  'distributor.filter.thisMonth': 'Este mes',
  'distributor.filter.last90': 'Ultimos 90 días',
  'distributor.filter.thisYear': 'Este ano',
  'distributor.filter.allStatus': 'Todos los estados',
  'distributor.filter.earnedInPeriod': 'Ganado en el periodo:',
  'distributor.periodo.semana': 'Semana',
  'distributor.periodo.30dias': '30 Días',
  'distributor.periodo.mes': 'Este Mes',
  'distributor.periodo.ano': 'Este Año',
  'distributor.periodo.todo': 'Todo',
  'distributor.comisionPeriodo': 'Comisión del Periodo:',
  'comisiones.titulo': 'Mis Comisiones',
  'comisiones.tituloAdmin': 'Comisiones Por Pagar',
  'comisiones.ganado': 'Ganado:',
  'comisiones.pagado': 'Pagado:',
  'comisiones.porPagar': 'Por Pagar:',
  'comisiones.porPagarTotal': 'Total Por Pagar:',
  'comisiones.solicitar': 'Solicitar Pago De {{monto}}',
  'comisiones.solicitada': 'Listo. Tu solicitud ya le llegó a la casa.',
  'comisiones.enCamino': 'Tu solicitud de {{monto}} está en camino. Te avisamos en cuanto se pague.',
  'comisiones.historial': 'Historial',
  'comisiones.estado.solicitado': 'Solicitado',
  'comisiones.estado.pagado': 'Pagado',
  'comisiones.estado.rechazado': 'Rechazado',
  'comisiones.solicitud': 'Solicitud',
  'comisiones.registrarPago': 'Registrar Pago',
  'comisiones.confirmar': 'Confirmar',
  'comisiones.referencia': 'Referencia (folio SPEI, efectivo…)',
  'comisiones.pagoRegistrado': 'Pago registrado. Al distribuidor ya le llegó su aviso.',
  'comisiones.rechazar': 'Rechazar',
  'comisiones.rechazada': 'Solicitud rechazada.',
  'comisiones.motivoRechazo': 'Motivo del rechazo (el distribuidor lo va a leer):',
  'comisiones.montoInvalido': 'El monto tiene que ser mayor que cero.',
  'comisiones.error': 'No se pudo. Intenta de nuevo.',

  'discount.codePlaceholder': 'Código de distribuidor',
  'discount.apply': 'Aplicar',
  'discount.codeApplied': 'Código {{code}} — {{rate}}% aplicado',
  'discount.noStack': 'Los descuentos no se acumulan: aplica el mayor entre tu código y el automático.',
  'discount.lineCode': 'Descuento código {{code}} ({{rate}}%)',
  'discount.lineSelf': 'Tu descuento ({{rate}}%)',
  'discount.codeMin': 'Este cupón aplica en compras desde {{amount}}. Agrega un poco más para que se active.',
  'admin.metaTab': 'Anuncios',
  'admin.tryTab': 'Intentos',
  'admin.try.title': 'Carritos que no se cerraron',
  'admin.try.sub': 'Gente que llegó al checkout y no compró. NO cuentan como pedidos ni como ingreso. Una hora después la IA les manda UNA sola oferta; abajo de {{min}} solo un recordatorio, sin cupón. El cupón exige comprar el mismo monto o más.',
  'admin.try.empty': 'Todavía no hay carritos abandonados.',
  'admin.try.pending': 'Sin cerrar',
  'admin.try.atStake': 'Dinero en juego',
  'admin.try.recovered': 'Recuperados',
  'admin.try.cart': 'Qué traía',
  'admin.try.offer': 'Oferta',
  'admin.try.sendNow': 'Mandar oferta',
  'admin.try.sentCode': 'Oferta enviada con el cupón {{code}}',
  'admin.try.sentNote': 'Recordatorio enviado (carrito chico, sin cupón)',
  'admin.try.followedUp': 'Ya se le escribió',
  'admin.try.status.pendiente': 'Sin cerrar',
  'admin.try.status.convertido': 'Ya compró',
  'admin.meta.title': 'Anuncios de Meta',
  'admin.meta.sub': 'Lo que gastas en Facebook e Instagram, cruzado con lo que el sitio de verdad vendió. Sube el CSV del Administrador de Anuncios (Informes → Exportar a CSV); cuando tengas el token de Meta esto se actualiza solo.',
  'admin.meta.upload': 'Subir CSV de Meta',
  'admin.meta.uploading': 'Leyendo…',
  'admin.meta.imported': '{{n}} campañas cargadas',
  'admin.meta.empty': 'Todavía no hay datos de Meta. Sube el CSV del Administrador de Anuncios para empezar a medir.',
  'admin.meta.live': 'En vivo desde Meta',
  'admin.meta.fromCsv': 'Desde CSV',
  'admin.meta.spend': 'Gastado',
  'admin.meta.reach': 'Personas alcanzadas',
  'admin.meta.clicks': 'Clics al sitio',
  'admin.meta.cpc': 'Costo por clic',
  'admin.meta.impressions': 'Impresiones',
  'admin.meta.purchases': 'Compras (Meta)',
  'admin.meta.siteRevenue': 'Vendido en el sitio',
  'admin.meta.campaign': 'Campaña',
  'admin.meta.killTitle': 'Candidatas a apagar',
  'admin.ficha.personalDiscount': 'Descuento permanente',
  'admin.ficha.personalDiscountHint': 'Compra siempre con este % sin necesidad de código. Se recorta al tope de cada producto; los insumos no entran. 0 lo quita.',
  'admin.ficha.personalDiscountBtn': 'Guardar',
  'discount.cappedTitle': 'Producto no participante.',
  'discount.cappedBody': 'Estos artículos no admiten el descuento completo; se aplicó un descuento alterno según el máximo que permite cada producto:',
  'discount.cappedNone': 'sin descuento',
  // LA REGLA DE 5 — precio de distribuidor desde 5 piezas del MISMO producto.
  'regla5.nudge': 'Llevas {{n}} De {{min}} — Agrega {{faltan}} Más Y Bajas Al Precio De Distribuidor',
  'regla5.add': 'Agregar {{faltan}}',
  'regla5.distPrice': 'Precio De Distribuidor (−{{rate}}%)',
  'regla5.clientPrice': 'Precio De Cliente (−{{rate}}%)',
  'regla5.title': 'Precio De Distribuidor Desde {{min}} Piezas',
  'regla5.body': 'Aplica por producto: {{min}} o más piezas del mismo. Estos van a precio de cliente:',
  'regla5.missing': 'faltan {{faltan}}',
  'admin.dist.customerDiscount': 'Descuento a sus clientes (%)',
  'admin.dist.customerDiscountHint': 'Entre 5% y 50%. No se acumula con el descuento automático: aplica el mayor.',
  'admin.dist.customerDiscountCol': 'Desc. clientes',
  'distributor.customerDiscountNote': 'Tu código da {{rate}}% de descuento a tus clientes.',

  'checkout.contactHint': 'Solo para enviarte la confirmacion y el seguimiento de tu pedido.',
  'checkout.shippingHint': 'Enviamos solo dentro de México.',
  'checkout.paymentHint': 'Selecciona como deseas pagar.',
  'checkout.card.number': 'Número de tarjeta',
  'checkout.card.expiry': 'Vencimiento',
  'checkout.card.name': 'Nombre en la tarjeta',
  'checkout.card.secureNote': 'Tus datos de tarjeta se procesan de forma segura y NUNCA se guardan en nuestros servidores.',
  'checkout.speiNote': 'Al confirmar tu pedido te enviaremos los datos bancarios (CLABE) para hacer tu transferencia SPEI. Tu pedido se procesa al recibir el pago.',
  'checkout.cryptoNote': 'Al confirmar te llevamos a una página segura para pagar con cripto. Ahí ves el monto exacto y el tiempo que tienes para pagarlo. Tu pedido se confirma solo en cuanto se recibe el pago.',
  'checkout.cryptoDiscountLine': 'Pago en cripto (−5%)',
  'checkout.consentText': 'Confirmo que soy mayor de 21 años y entiendo que los productos son exclusivamente para investigación (RUO). Acepto:',
  'checkout.payAmount': 'Pagar {{amount}} MXN',
  'checkout.toast.consent': 'Debes aceptar los términos para continuar',
  'checkout.toast.cardNumber': 'Revisa el número de tarjeta',
  'checkout.toast.cardExpiry': 'Revisa la fecha de vencimiento (MM/AA)',
  'checkout.toast.cardCvc': 'Revisa el CVC',
  'checkout.toast.cardName': 'Escribe el nombre como aparece en la tarjeta',

  'discount.headerBanner': 'Descuento automático: 10% de lanzamiento · 15% desde $35,000 — se aplica solo en el carrito, sin código',
  'discount.bannerTitle': 'Descuento automático',
  'discount.launch': 'lanzamiento',
  'discount.from20k': 'desde $35,000',
  'discount.noCode': 'Se aplica solo, sin código.',
  'discount.line': 'Descuento automático ({{rate}}%)',
  'discount.nextTier': 'Agrega {{amount}} mas y tu descuento sube a {{rate}}%.',
  'checkout.haveAccount': '¿Ya tienes cuenta?',
  'checkout.loginLink': 'Inicia sesión',
  'checkout.guestOk': 'o continua como invitado, sin cuenta.',
  'checkout.step1': 'Contacto',
  'checkout.step2': 'Envío',
  'checkout.step3': 'Pago',

  'auth.portal.title': 'Bienvenido a Exygen Labs',
  'auth.portal.subtitle': 'Entra o crea tu cuenta para comprar y dar seguimiento a tus pedidos.',
  'auth.securePayment': 'Pago seguro',

  'admin.inviteCustomer': 'Invitar cliente',
  'admin.invite.createdTitle': 'Cliente invitado',
  'admin.invite.emailSent': 'Le enviamos un correo de bienvenida. Compartele también su contraseña temporal (la cambia al entrar).',
  'admin.invite.send': 'Enviar invitacion',

  'footer.privacy': 'Política de privacidad',
  'auth.terms.service': 'Términos de servicio',
  'auth.terms.and': 'y',
  'auth.terms.privacy': 'Política de privacidad',

  'auth.side.title': 'Unete a la comunidad de investigadores',
  'auth.side.subtitle': 'Accede a beneficios exclusivos, seguimiento de pedidos y el mejor catálogo de péptidos en México.',
  'auth.side.benefit1': 'Acceso a ofertas exclusivas',
  'auth.side.benefit2': 'Historial de pedidos',
  'auth.side.benefit3': 'Seguimiento de envíos',
  'auth.side.hplc': 'Alta pureza HPLC',
  'auth.emailPlaceholder': 'tu@email.com',
  'auth.terms.pre': 'Al continuar, aceptas nuestros',
  'auth.terms.link': 'Términos y aviso RUO',
  'auth.backToSite': 'Volver al sitio',

  'profile.personal': 'Datos personales',
  'profile.phone': 'Teléfono',
  'profile.confirmWithPassword': 'Confirma tu contraseña actual (por el cambio de correo)',
  'profile.payment': 'Método de pago',
  'profile.preferredPayment': 'Método de pago preferido',
  'profile.paymentNote': 'Por tu seguridad NUNCA guardamos números de tarjeta. El pago se procesa siempre con el proveedor (Mercado Pago, banco, etc.); aquí solo guardamos tu preferencia.',
  'profile.shippingAddress': 'Dirección de envío',
  'profile.billingAddress': 'Dirección de facturacion',
  'profile.sameBilling': 'Usar la misma dirección para facturacion',
  'profile.addr.street': 'Calle y número',
  'profile.addr.city': 'Ciudad',
  'profile.addr.state': 'Estado',
  'profile.addr.zip': 'Código postal',
  'profile.addr.country': 'Pais',
  'profile.security': 'Seguridad',
  'profile.currentPassword': 'Contraseña actual',
  'profile.changePassword': 'Cambiar contraseña',
  'profile.save': 'Guardar cambios',
  'profile.saving': 'Guardando...',
  'profile.toast.saved': 'Perfil actualizado',
  'profile.toast.saveError': 'No se pudo guardar',
  'profile.toast.nameRequired': 'El nombre es obligatorio',
  'profile.toast.passwordForEmail': 'Escribe tu contraseña actual para cambiar el correo',
  'profile.toast.passwordChanged': 'Contraseña actualizada',

  'product.inHandStock': 'En stock — entrega inmediata ({{stock}} disponibles)',
  'product.oneWeekShip': 'Disponible — envío en ~1 semana',
  // ENVÍO PARTIDO (Christián, 2026-07-30): ninguna venta se bloquea por inventario.
  // Lo que hay sale ya; lo demás se manda pedir. Ya NO se anuncia como "dos entregas"
  // ni con plazos duros (Christián, 2026-07-30): una nota chiquita bajo CADA producto
  // sobre pedido, en el carrito, el checkout y la confirmación.
  'backorder.itemNote': 'Se surte desde EUA: tarda un poco más en llegar. Te mantendremos al tanto.',
  // ⛔ CÓMO QUIERE QUE LE MANDEMOS SU PEDIDO. Christián, 2026-07-31: cuando el pedido
  // no sale completo, la casa dejaba de partirlo o lo partía por su cuenta. Ahora se
  // le pregunta y se respeta. Los plazos son los de siempre, sin promesas nuevas.
  'shippingChoice.requerido': 'Elige cómo quieres que te mandemos tu pedido.',
  'shippingChoice.title': '¿Cómo prefieres que te lo mandemos?',
  'shippingChoice.hint': 'Una parte de tu pedido se surte desde EUA. Tú decides.',
  'shippingChoice.partido.label': 'Mándame Lo Disponible Ya',
  'shippingChoice.partido.desc': 'Lo que ya tenemos sale en 3 a 5 días y el resto después, en un segundo envío. Recibes dos números de guía, uno por cada envío.',
  'shippingChoice.completo.label': 'Prefiero Esperar Y Recibir Todo Junto',
  'shippingChoice.completo.desc': 'Sale todo en un solo envío cuando esté completo, aproximadamente en una semana. Un solo número de guía.',
  'backorder.badge': 'Sobre pedido — llega ~1 semana después',
  'backorder.cardNote': 'Sobre pedido (~1 semana)',
  'admin.stockTab': 'Inventario',
  'admin.stock.title': 'Inventario vivo · {{count}} presentaciones',
  'admin.stock.search': 'Buscar producto...',
  'admin.stock.hint': 'Cantidad se descuenta sola con cada compra. "En mano" = lo tienes fisicamente (el sitio muestra entrega inmediata); sin marcar = el sitio muestra ~1 semana.',
  'admin.stock.qty': 'Cantidad',
  'admin.stock.inHand': 'En mano',
  'admin.stock.shownAs': 'El cliente ve',
  'admin.stock.immediate': 'Entrega inmediata',
  'admin.stock.oneWeek': 'Envío en ~1 semana',

  'auth.showPassword': 'Mostrar contraseña',
  'auth.hidePassword': 'Ocultar contraseña',
  'auth.forgotLink': 'Olvide mi contraseña o usuario',
  'auth.forgot.title': 'Recuperar acceso',
  'auth.forgot.subtitle': 'Escribe el correo con el que te registraste (ese es tu usuario). Te enviaremos un enlace para restablecer tu contraseña.',
  'auth.forgot.submit': 'Enviar enlace',
  'auth.forgot.loading': 'Enviando...',
  'auth.forgot.error': 'No se pudo enviar. Intenta de nuevo.',
  'auth.forgot.sentTitle': 'Revisa tu correo',
  'auth.forgot.sentBody': 'Si {{email}} esta registrado, recibiras un enlace para restablecer tu contraseña (revisa spam).',
  'auth.forgot.backToLogin': 'Volver a iniciar sesión',
  'auth.reset.title': 'Nueva contraseña',
  'auth.reset.subtitle': 'Elige tu nueva contraseña (mínimo 6 caracteres).',
  'auth.reset.newPassword': 'Nueva contraseña',
  'auth.reset.confirmPassword': 'Confirmar contraseña',
  'auth.reset.submit': 'Guardar contraseña',
  'auth.reset.loading': 'Guardando...',
  'auth.reset.mismatch': 'Las contraseñas no coinciden',
  'auth.passwordHint': 'Tu contraseña debe tener al menos 6 caracteres.',
  'auth.confirmPassword': 'Confirmar contraseña',
  'verify.sentTitle': 'Revisa tu correo',
  'verify.sentBody': 'Le mandamos un enlace a {{email}}. Ábrelo para confirmar tu cuenta y poder entrar.',
  'verify.spamHint': 'Si no lo ves en unos minutos, busca en spam o en promociones.',
  'verify.blockedBody': 'Tu cuenta todavía no está confirmada. Abre el enlace que te mandamos por correo para poder entrar.',
  'verify.checking': 'Confirmando tu correo…',
  'verify.okTitle': '¡Listo, cuenta confirmada!',
  'verify.okBody': 'Te llevamos a tu cuenta en un momento.',
  'verify.errorTitle': 'No pudimos confirmar tu correo',
  'verify.failed': 'El enlace no es válido o ya expiró.',
  'verify.noToken': 'Este enlace viene incompleto. Ábrelo desde el correo que te mandamos.',
  'verify.resendLabel': 'Te mandamos uno nuevo',
  'verify.resendCta': 'Reenviar el correo',
  'verify.sending': 'Enviando…',
  'verify.resent': 'Si esa cuenta existe y falta confirmarla, ya va en camino un correo nuevo.',
  'verify.resendFailed': 'No pudimos reenviar el correo. Intenta en un momento.',
  'verify.needEmail': 'Escribe tu correo primero',
  'verify.backToLogin': 'Volver a iniciar sesión',
  'activate.loading': 'Abriendo tu invitación…',
  'activate.errorTitle': 'Esta invitación ya no sirve',
  'activate.invalid': 'La invitación no es válida o ya expiró. Pídenos una nueva.',
  'activate.noToken': 'Este enlace viene incompleto. Ábrelo desde el correo de invitación.',
  'activate.title': 'Hola, {{name}}',
  'activate.subtitle': 'Elige tu contraseña para activar tu cuenta. Con eso queda confirmado tu correo.',
  'activate.subtitleDistributor': 'Elige tu contraseña para activar tu portal de distribuidor. Con eso queda confirmado tu correo.',
  'activate.choosePassword': 'Tu nueva contraseña',
  'activate.cta': 'Activar mi cuenta',
  'activate.saving': 'Activando…',
  'activate.done': 'Cuenta activada',
  'activate.failed': 'No pudimos activar tu cuenta',

  // ---- Acuerdo de Distribuidor (aceptación electrónica) ----
  // ⛔ EL TEXTO LEGAL NO SE TRADUCE: lo manda el servidor y va en español, que
  // es el idioma que rige (cl. 20 del propio acuerdo: leyes mexicanas). Aquí
  // sólo se traduce la INTERFAZ. En inglés y portugués sale además la nota
  // 'acuerdo.legalNote' diciéndolo.
  'acuerdo.title': 'Acuerdo De Distribuidor',
  'acuerdo.subtitle': 'Antes de seguir operando como distribuidor, lee el acuerdo completo y acéptalo. Es el contrato que rige tu relación con Exygen Labs.',
  'acuerdo.subtitleUpdated': 'El acuerdo cambió en algo esencial, así que necesitamos tu aceptación otra vez. Lee la versión nueva y acéptala.',
  'acuerdo.checkbox': 'He leído y acepto el Acuerdo de Distribuidor en su versión {{version}}.',
  'acuerdo.accept': 'Aceptar Y Continuar',
  'acuerdo.accepting': 'Registrando tu aceptación…',
  'acuerdo.accepted': 'Acuerdo aceptado. Gracias.',
  'acuerdo.later': 'Ahora no, quiero ver mi panel',
  'acuerdo.error': 'No pudimos registrar tu aceptación. Inténtalo de nuevo.',
  'acuerdo.mustCheck': 'Marca la casilla para aceptar el acuerdo.',
  'acuerdo.versionLine': 'Versión {{version}} · {{fecha}}',
  'acuerdo.legalNote': 'El acuerdo está en español a propósito: esa es la versión que rige, conforme a las leyes mexicanas.',
  'acuerdo.blockedTitle': 'Tienes El Acuerdo De Distribuidor Pendiente',
  'acuerdo.blockedBody': 'Puedes ver tu panel y todo lo que ya ganaste. Mientras no lo aceptes, no se generan códigos nuevos, no se puede cotizar y no se acumulan comisiones nuevas.',
  'acuerdo.readAndAccept': 'Leer Y Aceptar',
  'acuerdo.download': 'Descargar Mi Copia',
  'acuerdo.downloadError': 'No pudimos preparar tu copia. Inténtalo de nuevo.',
  'acuerdo.acceptedOn': 'Aceptaste la versión {{version}} el {{fecha}}.',
  'acuerdo.pending': 'Todavía no has aceptado el acuerdo vigente.',
  'acuerdo.draftWarning': 'Este texto todavía es un borrador y tiene puntos por definir. No debería estar pidiéndose todavía: avísanos.',

  'auth.consent.age': 'Tengo 21 años o más, he leído y acepto los',
  'auth.consent.promos': 'Deseo activar bonos y participar en campañas',
  'auth.consent.email': 'Deseo recibir mensajes de marketing por correo electrónico',
  'auth.consent.privacy': 'Acepto la',
  'auth.consent.statement': 'Doy mi consentimiento para el tratamiento de mis datos con el fin de brindarme el servicio y comunicarme conmigo. He leído y entendido la Política de privacidad, que explica cómo tratamos mis datos personales y cuáles son mis derechos.',
  'auth.consent.submit': 'Sí, estoy de acuerdo',
  'auth.consent.required': 'Para crear tu cuenta necesitas confirmar que eres mayor de edad y aceptar la Política de privacidad.',
  'auth.reset.done': 'Contraseña actualizada. Inicia sesión.',
  'auth.reset.error': 'No se pudo actualizar. Solicita un enlace nuevo.',
  'auth.reset.noToken': 'Este enlace no es valido. Solicita uno nuevo.',

  'header.distributor': 'Panel Distribuidor',
  'distributor.title': 'Panel De Distribuidor',
  'distributor.subtitle': 'Hola, {{name}}. Tus ventas, clientes y ganancias.',
  'distributor.yourCode': 'Tu código',
  'distributor.copy': 'Copiar',
  'news.tab': 'Novedades',
  'news.empty': 'No tienes novedades por ahora.',
  'news.view': 'Ver',
  'adminNews.tab': 'Novedades',
  'adminNews.title': 'Centro de noticias',
  'adminNews.hint': 'Publica avisos para tus clientes y distribuidores. Las notificaciones automáticas (pedido entregado, nueva venta, subir de nivel, producto por terminarse…) se generan solas.',
  'adminNews.titlePlaceholder': 'Título del aviso',
  'adminNews.bodyPlaceholder': 'Mensaje (opcional)…',
  'adminNews.aud.all': 'Todos',
  'adminNews.aud.clients': 'Solo clientes',
  'adminNews.aud.distributors': 'Solo distribuidores',
  'adminNews.alsoEmail': 'Mandar también por correo (para lo importante)',
  'adminNews.publish': 'Publicar',
  'adminNews.none': 'Aún no has publicado avisos.',
  'adminNews.needTitle': 'Escribe un título.',
  'adminNews.sent': 'Aviso publicado',
  'adminNews.deleted': 'Aviso borrado',
  'adminNews.delete': 'Borrar',
  'adminNews.error': 'No se pudo. Intenta de nuevo.',
  'distributor.codeCopied': 'Código copiado',
  'distributor.codesTab': 'Mis Códigos',
  'distributor.codes.title': 'Mis códigos de descuento',
  'distributor.codes.autoHint': 'El sistema te da un código por cada nivel de descuento que puedes ofrecer (de 15% hasta 5% debajo de tu comisión). Se renuevan solos cada {{days}} días. Tú eliges cuál le das a cada cliente: lo que no des de descuento, te lo quedas.',
  'distributor.codes.rotateNow': 'Renovar códigos ahora',
  'distributor.codes.off': 'de descuento',
  'distributor.codes.copy': 'Copiar',
  'distributor.codes.hint': 'Crea varios códigos y elige cuál le das a cada cliente. El descuento va de 0% hasta tu comisión ({{max}}%). Lo que no des de descuento, te lo quedas.',
  'distributor.codes.label': 'Etiqueta',
  'distributor.codes.labelPlaceholder': 'Ej. Clientes nuevos, VIP…',
  'distributor.codes.discount': 'Descuento',
  'distributor.codes.create': 'Crear código',
  'distributor.codes.tip': 'El código lleva una parte al azar: nadie puede adivinar otro con más descuento. Caduca a los 90 días; renuévalo cuando quieras.',
  'distributor.codes.code': 'Código',
  'distributor.codes.status': 'Estado',
  'distributor.codes.actions': 'Acciones',
  'distributor.codes.none': 'Aún no tienes códigos. Crea el primero arriba.',
  'distributor.codes.active': 'Activo',
  'distributor.codes.inactive': 'Inactivo',
  'distributor.codes.expired': 'Caducado',
  'distributor.codes.renew': 'Renovar (nuevo código)',
  'distributor.codes.deactivate': 'Desactivar',
  'distributor.codes.created': 'Código creado',
  'distributor.codes.renewed': 'Código renovado',
  'distributor.codes.deactivated': 'Código desactivado',
  'distributor.codes.copied': 'Código copiado',
  'distributor.codes.error': 'No se pudo. Intenta de nuevo.',
  'distributor.commissionNote': 'Ganas el {{rate}}% de cada venta de tus clientes.',
  'distributor.level.title': 'Tu nivel',
  'distributor.level.tier.junior0': 'Junior 0',
  'distributor.level.tier.junior1': 'Junior 1',
  'distributor.level.tier.senior': 'Senior',
  'distributor.level.tier.master': 'Master',
  'distributor.level.tier.elite': 'Elite',
  'distributor.level.tier.diamond': 'Diamond',
  'distributor.level.rate': 'Comisión {{rate}}% · descuento máx {{rate}}%',
  'distributor.level.toNextTitle': 'Para subir a {{next}} necesitas las dos cosas:',
  'distributor.level.salesLabel': 'Ventas {{basis}}',
  'distributor.level.recruitsLabel': 'Reclutas activos en tu red',
  'distributor.level.basisPersonal': 'personales',
  'distributor.level.basisTeam': 'de equipo',
  'distributor.level.progressOf': '{{current}} de {{target}}',
  'distributor.level.approve': 'El ascenso lo aprueba Exygen al cumplir ambas metas.',
  'distributor.level.qualifies': '¡Ya calificas! Exygen aprueba tu ascenso.',
  'distributor.level.manual': 'El nivel Diamond es por invitación.',
  'distributor.level.top': '¡Nivel máximo! Estás en {{tier}} ({{rate}}%).',
  'distributor.level.ownEarnings': 'De tus ventas',
  'distributor.level.overrideEarnings': 'De tu equipo',
  'distributor.stats.earnings': 'Mis ganancias',
  'distributor.stats.sales': 'Ventas',
  'distributor.stats.orders': 'Pedidos',
  'distributor.stats.clients': 'Clientes',
  'distributor.overviewTab': 'Resumen',
  'distributor.clientsTab': 'Mis Clientes',
  'distributor.cotizadorTab': 'Cotizador',
  'distributor.salesTab': 'Mis Ventas',
  'distributor.noData': 'Aun no hay ganancias que graficar',
  // La ficha de un pedido (distribuidor y admin). Title Case en los titulos.
  'order.detail.what': 'Qué Compró',
  'order.detail.money': 'El Dinero',
  'order.detail.delivery': 'La Entrega',
  'order.detail.discount': 'Descuento ({{rate}}%)',
  'order.detail.discountWithCode': 'Descuento con {{code}} ({{rate}}%)',
  'order.detail.pointsUsed': 'Puntos canjeados',
  'order.detail.pointsEarned': 'Puntos ganados',
  'order.detail.shippingFree': 'Gratis (la casa absorbió {{amount}})',
  'order.detail.paid': '¿Ya pagó?',
  'order.detail.paidYes': 'Sí · {{when}}',
  'order.detail.paidNo': 'Todavía no · faltan {{amount}}',
  'order.detail.method': 'Cómo pagó',
  'order.detail.myCommission': 'Mi comisión',
  'order.detail.status': 'Estado',
  'order.detail.placed': 'Fecha del pedido',
  'order.detail.carrier': 'Paquetería',
  'order.detail.tracking': 'Guía',
  'order.detail.delivered': 'Entregado',
  'order.detail.forbidden': 'Ese pedido no es tuyo.',
  // «Ya no está» y «algo falló» son dos cosas distintas y se dicen distinto.
  'order.detail.deleted': 'Este pedido ya se borró, por eso no hay nada que ver aquí.',
  'order.detail.removeNotice': 'Quitar El Aviso',
  'order.detail.error': 'No se pudo abrir el pedido. Inténtalo otra vez en un momento.',
  'distributor.client.guest': 'Invitado',
  // Compró con su código sin abrir cuenta. Sigue siendo su cliente: la comisión ya se pagó.
  'distributor.noClients': 'Aun no tienes clientes',
  'distributor.noSales': 'Aun no tienes ventas',
  'distributor.earningsByMonth': 'Ganancias por mes',
  'distributor.clientsCount': '{{count}} clientes',
  'distributor.table.client': 'Cliente',
  'distributor.table.orders': 'Pedidos',
  'distributor.table.spent': 'Ha comprado',
  'distributor.table.myEarnings': 'Mi ganancia',
  'distributor.table.since': 'Cliente desde',
  'distributor.table.order': 'Pedido',
  'distributor.table.date': 'Fecha',
  'distributor.table.commission': 'Mi comision',
  'distributor.ordersTab': 'Pedidos Y Envíos',
  'nav.byCategory': 'Por categoría',
  'nav.learn': 'Aprende',
  'nav.group.tools': 'Herramientas',
  'header.logIn': 'Iniciar Sesión',
  'home.startHere': 'Empieza aquí',
  'header.getStarted': 'Comenzar',
  'nav.group.info': 'Información',
  'nav.advisor.desc': 'Tu plan en 3 pasos',
  'nav.calculator.desc': 'Cuánta agua y cuántas rayitas',
  'nav.compounds': 'Fichas de compuestos',
  'nav.compounds.desc': 'Ficha técnica de cada uno',
  'nav.guides': 'Antes de comprar',
  'nav.guides.desc': 'Todo explicado desde cero',
  'nav.education.desc': 'Literatura y fuentes',
  'nav.quality.desc': 'Pureza, COA y lotes',
  'nav.shipping.desc': 'Tiempos y cobertura',
  'nav.returns.desc': 'Garantía y reposiciones',
  'calc.publicSubtitle': 'Calcula cuánta agua bacteriostática agregar y cuántas rayitas jalar en la jeringa. Versión rápida y gratuita.',
  'calc.upsell.title': 'Los clientes tienen la versión completa',
  'calc.upsell.body': 'Al entrar a tu cuenta se desbloquea la calculadora avanzada y las herramientas personalizadas.',
  'calc.upsell.full': 'Dosis de referencia, modo "ya sé mi agua" y jeringa ajustable',
  'calc.upsell.purchases': 'Pre-carga los péptidos que TÚ compraste, con su presentación',
  'calc.upsell.refill': 'Te avisa cuando se te va a acabar el vial',
  'calc.upsell.export': 'Copiar, compartir por enlace y guardar en PDF',
  'calc.upsell.goTools': 'Ir a mis herramientas',
  'calc.upsell.signIn': 'Entrar a mi cuenta',
  'calc.yourPeptides': 'Lo que has comprado',
  'calc.track': 'Registrar seguimiento',
  'account.toolsTab': 'Mis Herramientas',
  'account.labsTab': 'Mis Estudios',
  'account.coasTab': 'Certificados',
  'account.fichasTab': 'Fichas Técnicas',
  'account.tools.lockedTitle': 'Tus herramientas se activan con tu primera compra',
  'account.tools.lockedNoOrders': 'La calculadora completa y el seguimiento de consumo son para clientes. En cuanto confirmemos el pago de tu primer pedido, se activan aquí.',
  'account.tools.lockedPending': 'Tu pedido todavía está pendiente de que confirmemos el pago. En cuanto lo verifiquemos, tus herramientas se activan aquí.',
  'account.tools.publicCalc': 'Usar la calculadora básica',
  'account.tools.calcHint': 'Versión completa. Elige uno de tus péptidos y calcula en un clic.',
  'account.tools.habitsTitle': 'Cuestionario De Hábitos',
  'account.tools.habitsHint': 'Dieta y hábitos básicos que acompañan tu rutina: agua, sueño, ejercicio y comida real.',
  'account.tools.trackTitle': 'Seguimiento y recompra',
  'account.tools.trackHint': 'Con tu dosis y frecuencia calculamos cuándo se te acaba el vial y te avisamos a tiempo.',
  'track.empty': 'Aún no registras ningún seguimiento. Usa el botón "Registrar seguimiento" en la calculadora.',
  'track.added': 'Seguimiento registrado',
  'track.removed': 'Seguimiento eliminado',
  'track.error': 'No se pudo guardar el seguimiento',
  'track.perDose': 'por aplicación',
  'track.dosesLeft': 'Te quedan {{left}} de {{total}} dosis',
  'track.runsOut': 'Se te acaba en {{days}} días ({{date}})',
  'track.reorderSoon': 'Pide más pronto',
  'track.reorder': 'Volver a pedir',
  'track.frequency': 'Cada cuánto',
  'track.vials': 'Viales en mano',
  'track.freq.daily': 'Diario (7 por semana)',
  'track.freq.fiveWeek': '5 veces por semana',
  'track.freq.threeWeek': '3 veces por semana',
  'track.freq.twoWeek': '2 veces por semana',
  'track.freq.weekly': '1 vez por semana',
  'track.freq.biweekly': 'Cada 2 semanas',
  'track.disclaimer': 'Estimación aritmética con los datos que tú capturaste. Uso exclusivo en investigación (RUO); no es una pauta de uso.',
  'admin.table.tracking': 'Guía',
  'admin.table.receipt': 'Comprobante',
  'admin.receipt.view': 'Ver',
  'admin.receipt.pending': 'Pendiente',
  'admin.receipt.none': 'Sin comprobante',
  'spei.receiptAsk': '¿Ya transferiste? Sube tu comprobante para agilizar la verificacion.',
  'spei.receiptCta': 'Subir comprobante',
  'spei.receiptUploading': 'Subiendo...',
  'spei.receiptOk': 'Comprobante recibido, gracias.',
  'spei.receiptDone': 'Comprobante recibido. Verificamos tu pago y te avisamos.',
  'admin.shipping.add': 'Poner guía',
  'admin.shipping.edit': 'Cambiar guía',
  'admin.order.pack': 'Qué va en la caja',
  // ENVÍO PARTIDO: qué sale hoy y qué hay que comprarle al proveedor.
  'admin.order.backorderTitle': 'Hay Que Mandar Pedir',
  'admin.order.backorderBadge': 'Sobre Pedido',
  'admin.order.backorderNow': 'Salen ya: {{n}}',
  'admin.order.backorderOrder': 'Mandar pedir: {{n}}',
  'admin.order.buyFrom': 'COMPRAR A: {{proveedor}}',
  'admin.order.noPhone': 'sin teléfono registrado',
  'admin.order.perVial': 'vial',
  'admin.order.noSupplier': '⚠️ Sin proveedor registrado — revisar el motor de precios',
  'admin.stats.toOrder': 'Por Surtir',
  'admin.order.backorderHint': 'Manda lo que hay y avisa cuando llegue el resto. Al cliente ya se le dijo que llega en dos entregas.',
  'admin.order.shipTo': 'Enviar a',
  'admin.order.copyAddress': 'Copiar dirección',
  'admin.order.copied': 'Dirección copiada',
  'admin.order.payment': 'Cobro',
  'admin.order.discount': 'Descuento',
  'admin.order.notes': 'Notas del cliente',
  'admin.order.delete': 'Borrar pedido',
  'admin.order.deleteTitle': '¿Borrar este pedido para siempre?',
  'admin.order.deleteBody': 'Vas a borrar {{n}} de {{name}} por {{total}}. Esto NO se puede deshacer: desaparece del panel, de los ingresos y de las comisiones.',
  'admin.order.deleteHint': 'Si fue una venta de verdad que se cayó, mejor ponle "Cancelado": deja rastro. Borrar es para lo que nunca debió estar ahí.',
  'admin.order.deleteConfirm': 'Sí, borrarlo',
  'admin.order.deleted': 'Pedido {{n}} borrado',
  // Selección múltiple en Pedidos: archivar / desarchivar / borrar en lote.
  'admin.filter.allStatuses': 'Todos Los Estados',
  // Filtro por DINERO, aparte del filtro por estado de la mercancía: entregado y
  // pagado son cosas distintas. Las tarjetas "Cobrado" y "Por Cobrar" del tablero
  // aterrizan aquí, ya puesto.
  'admin.filter.allPayments': 'Pagados Y No',
  'admin.filter.onlyPaid': 'Sólo Cobrados',
  'admin.filter.onlyDebt': 'Sólo Por Cobrar',
  'admin.lote.active': 'Activos',
  'admin.lote.archived': 'Archivados',
  'admin.lote.selected': '{{n}} seleccionado(s)',
  'admin.lote.selectAll': 'Seleccionar todos',
  'admin.lote.archive': 'Archivar',
  'admin.lote.unarchive': 'Desarchivar',
  'admin.lote.delete': 'Borrar',
  'admin.lote.deleteTitle': '¿Borrar {{n}} pedido(s) para siempre?',
  'admin.lote.deleteHint': 'Esto NO se puede deshacer: desaparecen del panel, de los ingresos y de las comisiones. Si sólo quieres limpiarlos de la vista, mejor archívalos.',
  'admin.lote.deleteConfirm': 'Sí, borrar {{n}}',
  'admin.lote.done.borrar': '{{n}} pedido(s) borrado(s)',
  'admin.lote.done.archivar': '{{n}} pedido(s) archivado(s)',
  'admin.lote.done.desarchivar': '{{n}} pedido(s) desarchivado(s)',
  'admin.lote.protectedTitle': 'Hay ventas pagadas en la selección',
  'admin.lote.protectedBody': 'No se borraron {{n}} porque ya están pagados (confirmado, enviado o entregado). Son ventas reales, con dinero que entró:',
  'admin.lote.forceHint': 'Borrarlos también borra sus ingresos y comisiones, y no hay deshacer. Sólo hazlo si estás COMPLETAMENTE seguro.',
  'admin.lote.force': 'Borrar también estos {{n}}',
  // PEDIDOS DE PRUEBA: quien prueba comprando en producción limpia lo que ensució.
  'admin.lote.markTest': 'Marcar Como Prueba',
  'admin.lote.unmarkTest': 'Quitar La Marca De Prueba',
  'admin.prueba.badge': 'Prueba',
  'admin.prueba.sweep': 'Barrer Pruebas',
  'admin.prueba.sweepTitle': 'Barrer los pedidos de prueba',
  'admin.prueba.sweepBody': 'Se van a borrar estos {{n}} pedidos marcados como prueba. No se puede deshacer.',
  'admin.prueba.sweepConfirm': 'Sí, barrer {{n}}',
  'admin.prueba.none': 'No hay nada que barrer: ningún pedido marcado como prueba se puede borrar.',
  'admin.prueba.protected': 'Estos {{n}} NO se van a tocar porque parecen ventas de verdad:',
  'admin.prueba.marked': '{{n}} pedido(s) marcado(s) como prueba',
  'admin.prueba.unmarked': '{{n}} pedido(s) ya no están marcados como prueba',
  'admin.prueba.done': '{{n}} pedido(s) de prueba borrado(s)',
  'admin.prueba.motivo.pagado': 'ya se pagó',
  'admin.prueba.motivo.surtido': 'ya se surtió',
  'admin.prueba.motivo.comprobante': 'tiene comprobante',
  'admin.prueba.motivo.guia': 'tiene guía',
  'admin.prueba.motivo.fantasma': 'ya no existe',
  'admin.shipping.title': 'Datos de envío',
  'admin.shipping.carrier': 'Paquetería',
  'admin.shipping.number': 'Número de guía',
  'admin.shipping.eta': 'Tiempo estimado',
  'admin.shipping.autoUrl': 'El enlace de rastreo se arma solo con la paquetería y la guía.',
  'admin.shipping.saved': 'Envío guardado',
  'admin.shipping.error': 'No se pudo guardar el envío',
  // Guía comprada sola por Skydropx (hoy apagado).
  'admin.shipping.label': 'Ver guía (PDF)',
  'admin.shipping.labelError': 'La guía no se pudo comprar sola:',
  'admin.repurchaseTab': 'Recompra',
  'admin.repurchase.hint': 'Clientes a los que se les está acabando el material, según el seguimiento que ellos registraron.',
  'admin.repurchase.daysLeft': 'Le quedan',
  'admin.repurchase.runsOut': 'Se le acaba',
  'admin.repurchase.days': '{{count}} días',
  'admin.repurchase.empty': 'Ningún cliente ha registrado seguimiento todavía',
  'distributor.ordersCount': '{{count}} pedidos de tus clientes',
  'distributor.noOrders': 'Tus clientes aún no han hecho pedidos',
  'distributor.table.destination': 'Destino',
  'distributor.table.items': 'Artículos',
  'distributor.table.shipping': 'Envío',
  'distributor.track': 'Rastrear',
  'distributor.noTracking': 'Sin guía todavía',
  'distributor.shippedOn': 'Enviado el {{date}}',
  'distributor.deliveredOn': 'Entregado el {{date}}',
  'distributor.copyTracking': 'Guía copiada',
  'distributor.ordersHint': 'Aquí ves el avance de cada pedido de tus clientes para poder darles seguimiento.',
  // El distribuidor captura la guía de SUS pedidos (Christián, 2026-07-30).
  'distributor.shipping.add': 'Poner Guía',
  'distributor.shipping.edit': 'Cambiar Guía',
  'distributor.shipping.title': 'Guía Del Pedido',
  'distributor.shipping.carrier': 'Paquetería',
  'distributor.shipping.number': 'Número De Guía',
  'distributor.shipping.url': 'Liga De Rastreo (Opcional)',
  'distributor.shipping.autoUrl': 'Si la dejas vacía, la liga se arma sola con la paquetería y el número.',
  'distributor.shipping.mailNote': 'Al guardar, tu cliente recibe su número de guía por correo.',
  'distributor.shipping.saved': 'Guía guardada. Tu cliente ya recibió el aviso.',
  'distributor.shipping.error': 'No se pudo guardar la guía',
  'distributor.shipping.needNumber': 'Escribe el número de guía',
  'admin.distributorsTab': 'Distribuidores',
  'admin.distributorsCount': '{{count}} distribuidores',
  'admin.newDistributor': 'Nuevo distribuidor',
  'admin.dist.name': 'Nombre',
  'admin.dist.email': 'Correo',
  'admin.dist.commission': 'Comision (%)',
  'admin.dist.editRates': 'Editar tasas',
  'admin.dist.editRatesTitle': 'Tasas de {{name}}',
  'admin.dist.commissionCap': 'Tope: 50%. El servidor lo exige.',
  'admin.dist.ratesForwardNote': 'El cambio aplica SOLO a ventas futuras. Lo ya vendido conserva su comision congelada, aunque cambien precios o tasas.',
  'admin.dist.ratesSave': 'Guardar tasas',
  'admin.dist.ratesSaved': 'Tasas actualizadas (solo hacia adelante).',
  'admin.dist.code': 'Código',
  'admin.dist.clients': 'Clientes',
  'admin.dist.sales': 'Ventas',
  'admin.dist.earnings': 'Ganancias',
  'admin.dist.create': 'Crear distribuidor',
  'admin.dist.createdTitle': 'Distribuidor creado',
  'admin.invite.emailOff': 'El envío de correos está apagado en el servidor, así que este correo NO salió. Pásale tú este enlace (vence en 7 días):',
  'admin.invite.linkCopied': 'Enlace copiado',
  'admin.invite.linkSent': 'Le mandamos un correo con un enlace para que elija su contraseña. El enlace vence en 7 días y al usarlo queda confirmado su correo. Nunca mandamos contraseñas por correo.',
  'admin.dist.shareCode': 'Su código de referido:',
  'admin.convert.button': 'Hacer distribuidor',
  'admin.convert.title': 'Convertir en distribuidor',
  'admin.convert.note': 'Conserva su historial de compras y su misma contraseña. Al convertirse deja de ganar y canjear puntos de lealtad, y su descuento sera unicamente el que fijes aquí (no se combina con otras promociones).',
  'admin.convert.confirm': 'Convertir',
  'admin.block.block': 'Bloquear',
  'admin.block.unblock': 'Desbloquear',
  'admin.block.badge': 'Bloqueado',
  'admin.block.confirm': '¿Bloquear a {{name}}? No podra entrar a su cuenta hasta que lo desbloquees. Sus datos y pedidos no se tocan.',
  'admin.block.done': 'Cuenta bloqueada',
  'admin.block.undone': 'Cuenta desbloqueada',
  'admin.apps.title': 'Solicitudes de distribuidor pendientes ({{count}})',
  'admin.apps.approve': 'Aprobar',
  'admin.apps.reject': 'Rechazar',
  'admin.apps.approveTitle': 'Aprobar solicitud de distribuidor',
  'admin.apps.rejectConfirm': '¿Rechazar la solicitud de {{name}}?',
  'admin.apps.rejected': 'Solicitud rechazada',
  'admin.apps.convertedNote': 'Su cuenta de cliente ya es distribuidor: entra con su misma contraseña.',
  'admin.apps.alreadyNote': 'Esta cuenta ya era distribuidor.',
  'b2b.cta': 'Quiero ser distribuidor',
  'b2b.form.title': 'Solicitud de distribuidor',
  'b2b.form.name': 'Nombre *',
  'b2b.form.email': 'Correo *',
  'b2b.form.phone': 'Teléfono',
  'b2b.form.kind': 'Tipo de negocio',
  'b2b.form.message': 'Cuentanos de tu operacion',
  'b2b.form.send': 'Enviar solicitud',
  'b2b.form.sent': 'Recibimos tu solicitud. La revisamos y te contactamos por correo — normalmente en 1 día habil.',
  'b2b.form.required': 'Nombre y correo valido son obligatorios',
  'b2b.form.error': 'No se pudo enviar. Intenta de nuevo.',
  'b2b.kind.clinica': 'Clínica',
  'b2b.kind.laboratorio': 'Laboratorio',
  'b2b.kind.revendedor': 'Revendedor',
  'b2b.kind.otro': 'Otro',
  'admin.dist.noDistributors': 'Aun no hay distribuidores',
  'admin.dist.close': 'Listo',
  'account.stats.orders': 'Pedidos',
  'account.stats.spent': 'Total comprado',
  'account.memberSince': 'Cliente desde {{date}}',

  // La descripción va en DOS partes porque la bandera de EUA se dibuja en medio,
  // dentro de la frase (como Certified). Juntas leen como una sola oración.
  // "Fabricado en EUA" es orden de Christian (2026-07-28): se dice "fabricados en
  // laboratorios de Estados Unidos" — laboratorios de terceros, nunca "nuestra planta".
  'footer.descriptionPre': 'El distribuidor de péptidos más grande de México. Péptidos fabricados en laboratorios de Estados Unidos',
  'footer.descriptionPost': ', con trazabilidad por lote, pureza verificada por HPLC y envíos dentro de México.',
  'footer.catalogTitle': 'Catálogo',
  'footer.infoTitle': 'Información',
  'footer.contactTitle': 'Contacto',
  'footer.recovery': 'Recuperación y tejidos',
  'footer.growth': 'Hormona de crecimiento',
  'footer.shipping': 'Envíos y entregas',
  'footer.returns': 'Devoluciones',
  'footer.prep': 'Preparación e inyección',
  'footer.quality': 'Calidad',
  'footer.terms': 'Términos y RUO',
  'footer.legalTitle': 'Aviso legal (RUO):',
  // Versión corta, en el tono de Certified (Christian, 2026-07-28): se quitó
  // "no para consumo humano ni animal", que asustaba, y se conservó el núcleo
  // RUO —fines informativos, investigación in vitro, sin promesa terapéutica—
  // que es lo que de verdad protege. Aquí también viven los métodos de pago:
  // antes tenían su propia sección y se sentía repetido.
  //
  // 2026-07-31 — Christian extendió esta misma decisión a TODO el sitio, los
  // correos y la hoja de cotización, porque la frase de consumo humano/animal
  // generaba reclamos. Se conserva ÚNICAMENTE en Términos y Condiciones
  // (info.terminos.body y src/data/info/terminos.js), que es exactamente como
  // lo tiene Certified: su pie y sus fichas no la traen, pero su "Aviso legal"
  // y su cláusula 3 de T&C sí. Ese es el respaldo defensivo; no lo quites de
  // ahí sin orden expresa.
  'footer.legalBody': 'Toda la información y las descripciones de producto de este sitio tienen fines educativos e informativos. Nuestros productos son solo para uso en investigación in vitro y no están destinados a diagnosticar, tratar, curar ni prevenir ninguna enfermedad.',
  'footer.paymentsInline': 'Pagos seguros:',
  'footer.backToTop': 'Volver arriba',
  'footer.rights': 'Exygen Labs. Todos los derechos reservados.',
  'footer.ruoLine': 'Research Use Only · Solo para investigación',
  'footer.flagMexico': 'Envíos en todo México',
  'controls.language': 'Idioma',
  // La puerta de entrada. Christian, 2026-07-31: «Haz el anuncio mucho más
  // pequeño. Copia el de Certified, que es pequeño» · «Recorta la cantidad de
  // info. Eres muy repetitivo». Antes eran un intro + tres puntos + una casilla
  // que decía "confirmo los tres puntos": cuatro maneras de decir lo mismo, 970
  // px de alto en un iPhone SE. Ahora son DOS frases —qué es y quién puede
  // comprarlo— y cabe entero sin scroll en 320x568.
  // ⚠️ No le agregues renglones. Si algo hace falta, va en Términos.
  'ruo.gate.badge': 'Solo investigación',
  'ruo.gate.title': 'Antes de entrar',
  'ruo.gate.intro': 'Todo lo que vendemos es material de laboratorio para investigación. No está destinado al consumo humano ni animal.',
  'ruo.gate.checkboxAge': 'Confirmo que tengo 21 años o más.',
  'ruo.gate.checkboxResearch': 'Adquiero estos productos únicamente para investigación de laboratorio.',
  'ruo.gate.remember': 'Recordar mi elección',
  'ruo.gate.accept': 'Entiendo y acepto',
  'ruo.gate.termsPre': 'Al continuar aceptas nuestros',
  'ruo.gate.leave': 'No acepto, salir',
  'controls.theme': 'Tema',
  'controls.appearance': 'Apariencia',
  'controls.preferences': 'Preferencias',
  'controls.dark': 'Oscuro',
  'controls.light': 'Claro',
  'theme.light': 'Claro',
  'theme.dark': 'Oscuro',
  'theme.system': 'Sistema',

  'common.catalog': 'Catálogo',
  'common.home': 'Inicio',
  'common.product': 'Producto',
  'common.purity': 'Pureza',
  'common.presentation': 'Presentación',
  'common.form': 'Forma',
  'common.method': 'Método',
  'common.shipping': 'Envío',
  'common.free': 'Gratis',
  'common.subtotal': 'Subtotal',
  'common.total': 'Total',
  'common.payment': 'Pago',
  'common.required': '*',
  // ---- Cotizador del distribuidor ("Mis Herramientas" → Cotizador) ----
  // ⛔ Aquí NO se nombra el costo, el proveedor ni el ROI: esta pantalla la ve el
  // distribuidor y el documento lo ve su cliente. Sólo precio público, el
  // descuento que él puede otorgar, y totales.
  'cotizador.titulo': 'Cotizador Para Tus Clientes',
  'cotizador.subtitulo': 'Arma la cotización, elige el descuento que das y compártela.',
  'cotizador.buscar': 'Busca un producto…',
  'cotizador.vacio': 'Agrega productos para armar la cotización.',
  'cotizador.cadaUno': 'c/u',
  'cotizador.descuento': 'Descuento Que Le Das',
  'cotizador.descuentoOtro': 'Otro %',
  'cotizador.topeNota': 'Hay productos que aguantan menos descuento y los insumos no llevan: cada renglón se ajusta solo.',
  'cotizador.promoCasa': 'Sin descuento tuyo, el cliente recibe la promo de la casa: {{pct}}% automático.',
  'cotizador.precioLista': 'Precio de lista',
  'cotizador.ahorro': 'Se ahorra',
  // ⛔ «Descuento X%», NO «ahorro» (Christián, 2026-08-01, textual: «Mónica no
  // entiende fácilmente»). El porcentaje se calcula descuento ÷ precio de lista.
  'cotizador.descuentoPct': 'Descuento {{pct}}%',
  'cotizador.envio': 'Envío',
  'cotizador.envioGratis': 'Gratis',
  'cotizador.envioPendiente': 'Se cotiza por separado',
  'cotizador.envioNota': 'El envío se cobra al pagar, con la política de la casa.',
  'cotizador.total': 'Total',
  'cotizador.nombreCliente': 'Nombre de tu cliente (opcional)',
  'cotizador.correoCliente': 'Correo (opcional)',
  'cotizador.telCliente': 'Teléfono (opcional)',
  'cotizador.dirCliente': 'Dirección (opcional)',
  'cotizador.generar': 'Generar Cotización',
  'cotizador.docTitulo': 'Cotización',
  'cotizador.docPara': 'Para',
  'cotizador.docDe': 'De',
  'cotizador.docFolio': 'Folio',
  'cotizador.docSinNombre': 'Cliente',
  'cotizador.docAntes': 'Antes',
  'cotizador.colProducto': 'Producto',
  'cotizador.colCant': 'Cant.',
  'cotizador.colUnitario': 'Precio unitario',
  'cotizador.colImporte': 'Importe',
  'cotizador.docDinero': 'El Dinero',
  // ⛔ «El Dinero» FUERA (Christián, 2026-08-01): «no aplica bien en español».
  // Se deja un encabezado neutro para que el bloque no quede huérfano.
  'cotizador.docResumen': 'Resumen',
  'cotizador.docVerCotizacion': 'Vuelve a ver esta cotización:',
  'cotizador.docVerCotizacionTexto': 'Abrir mi cotización',
  'cotizador.docPagarTexto': 'Pagar con mi carrito listo',
  'cotizador.waVerCotizacion': 'Vuelve a ver tu cotización cuando quieras:',
  'cotizador.docAhorro': 'Ahorro',
  'cotizador.docAhorroCaja': 'Se ahorra',
  'cotizador.docDescuento': 'Descuento {{pct}}%',
  'cotizador.docDescuentoCaja': 'Descuento {{pct}} · se ahorra',
  'cotizador.docEnvio': 'Envío',
  'cotizador.docEnvioGratis': 'Gratis',
  'cotizador.docCripto': 'Pagando en criptomonedas se aplica 5% de descuento adicional sobre este total.',
  'cotizador.docCortesia': 'Cortesía',
  // --- Obsequios y carrito compartible (Christián, 2026-08-01) ---
  'cotizador.obsequios': 'Obsequios Para Tu Cliente',
  'cotizador.obsequiosNota': 'Lo que regales se apila con tu descuento. Tu cliente ve el regalo, nunca el código.',
  'cotizador.obsequioAgregar': 'Agregar Obsequio',
  'cotizador.obsequioProducto': 'Producto de cortesía',
  'cotizador.obsequioEnvio': 'Envío de cortesía',
  'cotizador.obsequioBuscar': 'Busca el producto que vas a regalar…',
  'cotizador.obsequioQuitar': 'Quitar obsequio',
  'cotizador.obsequioCantidad': 'Cuántas piezas de cortesía',
  'cotizador.obsequioSinMargen': 'Ese obsequio no cabe: entre tu descuento y el regalo se van {{entregado}} y este pedido aguanta {{permitido}}. Baja el descuento o el regalo.',
  'cotizador.compartirCarrito': 'Compartir Carrito',
  'cotizador.compartirCarritoNota': 'Se crea un enlace con este carrito ya armado. Tu cliente lo abre en su teléfono, sin cuenta, y la venta se te acredita.',
  'cotizador.carritoListo': 'Enlace del carrito listo',
  'cotizador.carritoError': 'No se pudo crear el enlace. Intenta de nuevo.',
  'cotizador.carritoCopiar': 'Copiar Enlace',
  'cotizador.carritoCopiado': 'Enlace copiado',
  'cotizador.waCarrito': 'Abre tu carrito ya armado:',
  // --- Carrito compartido: la pantalla del CLIENTE (Christián, 2026-08-01) ---
  'carritoCompartido.titulo': 'Tu Carrito Está Listo',
  'carritoCompartido.subtitulo': 'Ya lo dejamos armado con tus precios. Solo revisa y paga.',
  'carritoCompartido.paraCliente': 'Preparado para {{nombre}}. Ya trae tus precios: solo revisa y paga.',
  'carritoCompartido.cortesia': 'Cortesía',
  'carritoCompartido.envioCortesia': 'Envío de cortesía',
  'carritoCompartido.comprar': 'Comprar Ahora',
  'carritoCompartido.nota': 'Precios en MXN. El total final lo confirma la caja al pagar.',
  'carritoCompartido.vencido': 'Este carrito ya venció. Pídele uno nuevo a quien te lo mandó.',
  'carritoCompartido.noExiste': 'No encontramos este carrito. Puede que el enlace esté incompleto.',
  'carritoCompartido.verCatalogo': 'Ver El Catálogo',
  // --- Mis Cotizaciones: la lista guardada en el panel (Christián, 2026-08-01) ---
  'cotizaciones.tab': 'Mis Cotizaciones',
  'cotizaciones.col.folio': 'Folio',
  'cotizaciones.col.cliente': 'Cliente',
  'cotizaciones.col.fecha': 'Fecha',
  'cotizaciones.col.acciones': 'Acciones',
  'cotizaciones.estado.cotizacion': 'Cotización',
  'cotizaciones.estado.pedido': 'Pedido Sin Pagar',
  'cotizaciones.estado.venta': 'Venta',
  'cotizaciones.filtro.todas': 'Todas',
  'cotizaciones.filtro.archivadas': 'Archivadas',
  'cotizaciones.archivar': 'Archivar',
  'cotizaciones.desarchivar': 'Desarchivar',
  'cotizaciones.borrar': 'Borrar',
  'cotizaciones.seleccionarTodas': 'Seleccionar Todas',
  'cotizaciones.borrarConfirm': '¿Borrar {{count}} cotización(es)? El enlace del cliente deja de funcionar.',
  'cotizaciones.borradas': 'Se borraron {{count}}.',
  'cotizaciones.archivadas': 'Se archivaron {{count}}.',
  'cotizaciones.desarchivadas': 'Se regresaron {{count}}.',
  'cotizaciones.protegidas': '{{count}} ya son ventas: no se borran, se archivaron.',
  'cotizaciones.vacio': 'Todavía no has generado ninguna cotización.',
  'cotizaciones.vencida': 'Ya venció',
  'cotizaciones.actualizar': 'Actualizar',
  'cotizaciones.whatsapp': 'WhatsApp',
  'cotizaciones.correo': 'Correo',
  'cotizaciones.abrir': 'Abrir',
  'cotizaciones.vendido': 'Vendido:',
  'cotizaciones.resumen': '{{cotizaciones}} por cerrar · {{ventas}} vendidas',
  'cotizaciones.nota': 'Cuando tu cliente paga, la cotización deja de serlo y aparece aquí como venta con su número de pedido. El enlace ya trae los datos de tu cliente: su checkout llega lleno.',
  'cotizador.docCatalogo': 'Compra en el catálogo:',
  'cotizador.docPagar': 'Paga en línea (tu carrito ya va armado):',
  'cotizador.docLeyenda': 'Productos para uso en investigación (RUO). Cotización informativa, vigencia de 7 días. Precios en MXN.',
  'cotizador.docCodigo': 'Código:',
  'cotizador.waEnlace': 'Ver el catálogo:',
  'cotizador.waPagar': 'Págala en línea (el carrito ya va armado):',
  'cotizador.vistaPrevia': 'Vista Previa',
  'cotizador.compartir': 'Compartir Por WhatsApp',
  'cotizador.imprimir': 'Imprimir',
  'cotizador.enviarCorreo': 'Enviar Por Correo',
  'cotizador.enviar': 'Enviar',
  'cotizador.correoPide': 'Correo de tu cliente',
  'cotizador.correoNota': 'Le llega la cotización con tu código y un botón que abre el carrito ya armado, para que la compra se te acredite.',
  // Tu cliente no sabe que el código es tuyo: quien firma es la casa.
  'cotizador.correoPrivacidad': 'Tu nombre y tu correo no viajan: el correo lo firma Mónica Flores, de atención a clientes, y si tu cliente responde nosotros te pasamos el recado. La venta sigue siendo tuya.',
  'cotizador.correoEnviado': 'Cotización enviada a {{email}}',
  'cotizador.correoInvalido': 'Ese correo no se ve bien. Revísalo.',
  'cotizador.correoError': 'No se pudo enviar la cotización. Intenta de nuevo.',
  // ⛔ Cuando el correo está APAGADO en el servidor no hay nada que reintentar:
  // se dice tal cual y se ofrece la salida que sí funciona.
  'cotizador.correoApagado': 'El envío por correo está apagado en el servidor. No salió nada.',
  'cotizador.correoAlternativa': 'Mándala por WhatsApp o copia el enlace del carrito: los dos funcionan ahora mismo.',
  'cotizador.correoDemasiados': 'Vas muy rápido: espera un momento antes de mandar otra.',
  'common.close': 'Cerrar',
  'common.remove': 'Quitar',
  'common.cancel': 'Cancelar',
  'common.saveChanges': 'Guardar cambios',
  'common.createProduct': 'Crear producto',
  'common.loading': 'Procesando...',
  'common.previous': 'Anterior',
  'admin.meta.linkClicks': 'Clics al enlace',
  'admin.meta.allClicks': 'de {{n}} clics en total',
  'admin.meta.landings': 'Llegaron al sitio',
  'admin.meta.ofClicks': 'de los clics',
  'admin.series.visitors': 'Visitantes',
  'admin.series.title': 'Tráfico y ventas en el tiempo',
  'admin.series.day': 'Día',
  'admin.series.week': 'Semana',
  'admin.series.month': 'Mes',
  'admin.series.sessions': 'Sesiones',
  'admin.series.orders': 'Pedidos',
  'admin.series.revenue': 'Ingreso',
  'admin.series.conversion': 'Conversión',
  'checkout.oxxoNote': 'Al confirmar te llevamos a Mercado Pago para generar tu ficha de pago en OXXO. Llévala a cualquier tienda y paga en efectivo; tu pedido se confirma solo, en cuanto OXXO nos avisa (puede tardar unas horas).',
  'checkout.cardNote': 'Al confirmar te llevamos a la página segura de Mercado Pago para pagar con tarjeta. Tus datos de tarjeta nunca pasan por nuestro sitio. Tu pedido se confirma solo en cuanto se recibe el pago.',
  'home.tab.featured': 'Más vendidos',
  'home.tab.new': 'Nuevos',
  'home.tab.weight': 'Bajar de peso',
  'home.tab.recovery': 'Recuperación',
  'home.tab.growth': 'Hormona de crecimiento',
  'common.next': 'Siguiente',
  'common.quantityPrefix': 'x{{count}}',
  'common.items': '{{count}} artículo(s)',
  'common.piecesFrom': '{{price}} desde {{qty}} pzas',

  'home.badge': 'Pureza verificada por HPLC',
  'home.heroTitle': 'Ciencia y precisión, lote por lote',
  // El hero ya no dice solo "péptidos liofilizados": dice de DÓNDE salen. Certified
  // vende su procedencia gringa desde el primer renglón y a nosotros nos costaba el
  // comparativo — nuestra materia prima viene de laboratorios de Estados Unidos, así
  // que se dice desde el primer renglón.
  //
  // ⛔ NUNCA se menciona Asia en el sitio, en ningún idioma. Orden expresa de Christian
  // (2026-07-28). Si vuelves a escribir de dónde sale el material, esta es la regla.
  'home.heroBody': 'Péptidos liofilizados de investigación, fabricados en laboratorios de Estados Unidos.',
  'home.heroRuo': 'Solo para uso en investigación (RUO).',

  // ===== "El más grande de México" (Christian, 2026-07-28) =====
  // El adjetivo lo puede escribir cualquiera; la cuenta no. Por eso la frase NUNCA
  // va sola: siempre la acompaña el número de presentaciones, que es lo que se puede
  // comprobar abriendo el catálogo. Y el número no está escrito a mano — Home.js lo
  // cuenta del catálogo del sitio, así que si se oculta un producto la cifra baja
  // sola y la portada nunca queda prometiendo algo que ya no está.
  'home.leadBadge': 'El distribuidor de péptidos más grande de México · {{presentaciones}} presentaciones',
  'home.leadKicker': 'Variedad',
  'home.leadTitle': '¡Somos el distribuidor de péptidos más grande en México!',
  'home.leadBody': 'Somos los que más variedad ofrecemos: {{presentaciones}} presentaciones a la venta en {{categorias}} categorías de investigación.',
  'home.leadCta': 'Ver las {{presentaciones}} presentaciones',
  'home.leadStat1': 'Presentaciones a la venta',
  'home.leadStat2': 'Compuestos distintos',
  'home.leadStat3': 'Categorías de investigación',
  'home.leadUsa.title': 'Fabricado en Estados Unidos',
  'home.leadUsa.body': 'Nuestros péptidos se fabrican en laboratorios de Estados Unidos y pasan por el mismo estándar analítico: pureza por HPLC, lote por lote.',
  'home.presentations': 'Presentaciones a la venta',
  'home.viewCatalog': 'Ver catálogo',
  // Segundo botón del hero (Christián, 2026-07-31): antes decía "Empieza aquí" y
  // llevaba a una guía. Ahora lleva al Asesor, que estaba escondido.
  'home.advisorCta': 'Arma Mi Plan',
  'home.verifyPurity': 'Cómo verificamos la pureza',
  'home.eduKicker': 'Aprende',
  'home.eduTitle': 'Antes de tu primer pedido',
  'home.eduSubtitle': 'Tres cosas que todo investigador debe saber',
  'home.edu1.title': '¿Qué significa RUO?',
  'home.edu1.body': 'Todos nuestros compuestos son solo para uso en investigación (Research Use Only). No son medicamentos ni suplementos.',
  'home.edu2.title': 'Cómo leer tu análisis de pureza',
  'home.edu2.body': 'Tu reporte documenta la identidad y pureza del compuesto medidas por HPLC y espectrometría de masas.',
  'home.edu3.title': 'El certificado de tu lote',
  'home.edu3.body': 'Cada lote se analiza por HPLC antes de salir. Después de tu compra te entregamos, en digital, el certificado del lote que te tocó: no tienes que pedirlo.',
  'home.rep.name': 'Mónica Flores',
  'home.rep.role': 'Representante de ventas',
  'home.rep.body': 'Una persona real del otro lado: Mónica te ayuda a armar tu pedido, resuelve dudas de envío y pago, y te da seguimiento hasta que llega. Lunes a sábado.',
  'home.rep.cta': 'Escribirle a Mónica',
  'home.rep.prefill': 'Hola Mónica, vengo del sitio de Exygen Labs y tengo una duda.',
  'home.b2bKicker': 'Mayoreo',
  'home.b2bTitle': '¿Clínica, laboratorio o revendedor?',
  'home.b2bBody': 'Precios por volumen, atención dedicada y despacho prioritario para pedidos grandes.',
  'home.b2bCta1': 'Cotizar por correo',
  'home.b2bCta2': 'Ver catálogo completo',
  'home.stamp.title': 'Descuento de introducción',
  'home.stamp.sub': 'Descuentos por introducción del 10 al 15%',
  'home.typicalPurity': 'Pureza típica',
  'home.products': 'Productos',
  'home.nationalShipping': 'Envío nacional',
  // Textos CORTOS de la franja "Tienda de Confianza" de la portada (variante
  // `strip` de TrustBadges). Son de un renglón a propósito: en pantalla grande la
  // franja son seis columnas. Las versiones largas viven abajo, en `trust.*`.
  'home.trust.coa.title': 'Certificado De Tu Lote',
  'home.trust.coa.desc': 'En digital, después de tu compra',
  'home.trust.purity.title': 'Pureza ≥ 99%',
  'home.trust.purity.desc': 'Verificada por HPLC',
  'home.trust.shipping.title': 'Envío Nacional',
  'home.trust.shipping.desc': '3 a 5 días, empaque discreto',
  'home.trust.support.title': 'Soporte Por WhatsApp',
  'home.trust.support.desc': 'Te contestamos en español',
  // Quinto sello de la barra de confianza: es el lugar donde el visitante compara
  // garantías de un vistazo, y es justo ahí donde Certified pone su "fabricado en
  // EE. UU.". Nosotros ponemos lo que sí es nuestro: de dónde compramos.
  'home.trust.origin.title': 'Fabricado En EUA',
  'home.trust.origin.desc': 'En laboratorios de Estados Unidos',
  // Sexto sello (2026-07-29): el visitante que nunca nos compró quiere saber CÓMO
  // paga antes de meter nada al carrito. Es un hecho comprobable, no una promesa.
  'home.trust.payment.title': 'Pago Seguro',
  'home.trust.payment.desc': 'OXXO, SPEI, tarjeta y cripto',
  // ===== Bloque "Tienda de confianza" (componente TrustBadges) =====
  // Cada línea tiene que poder comprobarse. No hay devoluciones, ni garantía de
  // meses, ni reenvíos gratis: las ventas son finales y el envío se cotiza aparte.
  'trust.title': 'Tienda De Confianza',
  'trust.subtitle': 'Lo que sí podemos comprobarte en cada pedido.',
  'trust.purity.title': 'Pureza Verificada Por HPLC',
  'trust.purity.desc': 'Cada lote se analiza por HPLC antes de salir.',
  'trust.coa.title': 'Certificado De Tu Lote',
  'trust.coa.desc': 'Después de tu compra te entregamos, en digital, el certificado del lote que recibiste.',
  'trust.origin.title': 'Fabricado En Estados Unidos',
  'trust.origin.desc': 'En laboratorios de Estados Unidos.',
  'trust.shipping.title': 'Envío Nacional En 2 A 5 Días',
  'trust.shipping.desc': 'A todo México, con empaque discreto y número de rastreo.',
  'trust.payment.title': 'Pago Seguro',
  'trust.payment.desc': 'OXXO, SPEI, tarjeta y cripto. El monto lo confirma nuestro servidor en cada pedido.',
  'trust.support.title': 'Soporte Por WhatsApp',
  'trust.support.desc': 'Escríbenos al {{phone}}.',
  'trust.ruo': 'Material exclusivamente para investigación (RUO), en laboratorio y ensayos in vitro. No es para uso diagnóstico ni terapéutico.',
  // ===== Widget colapsable "Tienda de confianza" (componente TrustWidget) =====
  // Diseño pedido por Christian (2026-07-30): tarjeta verde, colapsable, con
  // resumen de 3 columnas y una lista de certificaciones al abrir. Reutiliza
  // trust.purity.title y trust.payment.title de arriba para dos renglones de
  // la lista — SSL y la política de privacidad son los únicos textos nuevos,
  // y los dos son verificables (candado del navegador, /info/privacidad).
  'trustWidget.panelTitle': 'Esta Tienda Cuenta Con Las Siguientes Certificaciones',
  'trustWidget.check.shipping': 'Envío Rápido Incluido (3-5 Días Hábiles)',
  'trustWidget.check.ssl': 'Conexión Segura (SSL)',
  'trustWidget.check.privacy': 'Política De Privacidad Publicada',
  'trustWidget.toggleExpand': 'Ver Certificaciones',
  'trustWidget.toggleCollapse': 'Ocultar Certificaciones',
  'home.categoriesTitle': 'Explora por categoría',
  'home.categoriesSubtitle': 'Encuentra el péptido según tu objetivo de investigación',
  'home.featuredTitle': 'Productos destacados',
  'home.featuredSubtitle': 'Los más solicitados por la comunidad de investigación',
  'home.viewAll': 'Ver todo',
  'home.transparencyTitle': 'Transparencia total por lote',
  'home.transparencyBody': 'Cada lote se analiza por HPLC y queda registrado con su propio certificado. Nuestros péptidos se fabrican en laboratorios de Estados Unidos, y después de tu compra te entregamos en digital el certificado del lote que te corresponde, sin que tengas que pedirlo.',
  'home.transparency.bullet1': 'Pureza analizada por HPLC en cada lote',
  'home.transparency.bullet2': 'Certificado del lote que te tocó, sin pedirlo',
  'home.transparency.bullet3': 'Almacenamiento y manejo documentados',
  // El cuarto paso de trazabilidad es el origen: de nada sirve rastrear el lote si
  // no se dice de qué laboratorio salió.
  'home.transparency.bullet4': 'Fabricado en laboratorios de Estados Unidos',
  'home.learnProcess': 'Conoce nuestro proceso',
  'home.ruoNotice': 'Nuestros productos son solo para uso en investigación in vitro y no están destinados a diagnosticar, tratar, curar ni prevenir ninguna enfermedad. Su uso es responsabilidad exclusiva de investigadores calificados.',
  'home.labAlt': 'Laboratorio Exygen Labs',
  'home.coaAlt': 'Transparencia y COA',
  'home.kicker': 'Research Grade Peptides',
  'home.photos.bench': 'Análisis de identidad y pureza en laboratorio',
  'home.photos.pipetting': 'Preparación de muestra para HPLC',
  'home.photos.sample': 'Alícuota de la muestra que se analiza',
  'home.photos.multichannel': 'Ensayo en placa, por lote',
  'home.photos.lyo': 'Péptido liofilizado en vial sellado',
  'home.photos.filling': 'Línea de envasado en el laboratorio',
  'home.photos.capping': 'Taponado y engargolado de cada vial',
  'home.madeInUsa': 'Fabricado en EUA',
  'home.shippingValue': '3–5 días',
  'home.coa.header': 'Certificado de Análisis',
  'home.coa.product': 'Producto',
  'home.coa.presentation': 'Presentación',
  'home.coa.purityLabel': 'Pureza HPLC',
  'home.purityHplc': 'Pureza por HPLC',
  'home.freeShipValue': '5%',
  'home.freeShipLabel': 'Extra pagando en cripto',
  'home.coa.batch': 'Lote',
  'home.coa.statusApproved': 'Aprobado',
  'home.coa.statusNote': 'Verificado por HPLC',
  'home.coa.footnote': 'COA específico por lote. Después de tu compra te entregamos, en digital, el que corresponde a tu pedido.',
  'home.categoriesKicker': 'Catálogo',
  'home.featuredKicker': 'Destacados',
  'home.transparencyKicker': 'Trazabilidad',
  'home.whyKicker': 'Comparativa',
  'home.whyTitle': '¿Por qué Exygen Labs?',
  'home.whySubtitle': 'Lo que separa el material de investigación serio del resto',
  'home.why.others': 'Otros vendedores',
  'home.why.partial': 'Parcial',
  'home.why.r1': 'Trazabilidad por lote en cada producto',
  'home.why.r2': 'Pureza verificada por HPLC ≥99%',
  'home.why.r3': 'Certificado del lote, entregado sin pedirlo',
  'home.why.r4': 'Envío nacional en 3–5 días',
  'home.why.r5': 'Soporte experto en español 24/7',
  'home.why.r6': 'Precios claros en MXN',
  // Los dos renglones que de verdad nos separan: nadie en México tiene más
  // presentaciones, y casi nadie dice de dónde viene su materia prima. Van
  // PRIMEROS en la tabla (ver whyRows en Home.js): Certified pone su "fabricado
  // en EE. UU." como primer argumento de su comparativa y aquí se leía hasta el
  // final. El renglón del origen dice explícitamente que los péptidos salen de
  // laboratorios de Estados Unidos — es lo que Christian pidió que dijera esta
  // sección (2026-07-28). No se promete fábrica propia, ni domicilio en EUA, ni
  // FDA: solo lo comprobable, que es de dónde se compra el material.
  'home.why.r7': 'El catálogo más amplio de México ({{presentaciones}} presentaciones)',
  'home.why.r8': 'Fabricado en laboratorios de Estados Unidos',
  'home.paymentsTitle': 'Pagos seguros y protegidos',
  'home.paymentsNote': 'Elige el método que prefieras al finalizar tu compra.',
  'home.explore': 'Explorar',
  'nav.catalog': 'Catálogo',
  'nav.cart': 'Carrito',
  'cart.shippingFree': 'Gratis',
  'cart.shippingQuoted': 'Se cotiza por separado',
  'cart.freeShippingAt': 'Te faltan {{amount}} para que el envío sea gratis.',
  'nav.tutorials': 'Tutoriales',
  'footer.startHere': 'Empieza aquí',
  'footer.howToReconstitute': 'Cómo reconstituir',
  'footer.compendium': 'Fichas de compuestos',
  'footer.allGuides': 'Todas las guías',
  // Enlaces a lo que salió de la portada en teléfono (Christián, 2026-07-31).
  // Nada se borró: desde aquí se llega a todo.
  'footer.comparison': 'Comparativa Contra Otros',
  'footer.wholesale': 'Mayoreo Y Distribuidores',
  'footer.traceability': 'Cómo Verificamos Cada Lote',
  'footer.labPhotos': 'Fotos Del Laboratorio',
  'footer.stacks': 'Stacks / Combos',
  'nav.peptides': 'Péptidos',
  'nav.tools': 'Recursos',
  'nav.help': 'Ayuda',
  'nav.contact': 'Contacto',
  'nav.contact.desc': 'Canales, horarios y respuesta',
  'nav.support': 'Centro de soporte',
  'nav.support.desc': 'Pagos, accesos y fallas',
  'nav.orderStatus': 'Estado de mi pedido',
  'nav.orderStatus.desc': 'Estados y rastreo de guia',
  'nav.faq': 'Preguntas frecuentes',
  'nav.faq.desc': 'Respuestas rápidas',
  'nav.advisor': 'Asesor de péptidos',
  'nav.calculator': 'Calculadora de reconstitución',
  'nav.education': 'Educación',
  'edu.title': 'Guía para empezar con péptidos de investigación',
  'edu.subtitle': 'Una introducción clara para quien apenas comienza: qué son, cómo se estudian y dónde leer la literatura científica original.',
  'edu.ruoTitle': 'Solo para uso en investigación (RUO)',
  'edu.ruoBody': 'Todos nuestros productos son exclusivamente para investigación de laboratorio. No son medicamentos ni suplementos, y nada en esta página es consejo médico. Consulta siempre a un profesional de la salud.',
  'edu.whatTitle': '¿Qué son los péptidos?',
  'edu.whatBody': [
    'Los péptidos son cadenas cortas de aminoácidos, los mismos bloques que forman las proteínas. El cuerpo produce miles de ellos de forma natural para señalizar procesos como reparación de tejido, metabolismo o inflamación.',
    'En investigación se estudian versiones sintéticas para entender esos procesos. Llegan liofilizados (en polvo) y se reconstituyen con agua bacteriostática antes de manejarse en el laboratorio.',
    'Cada compuesto tiene su propia evidencia: algunos cuentan con ensayos clínicos en humanos (como los análogos de GLP-1), mientras que otros solo tienen estudios preclínicos en animales o células. Leer la fuente original te ayuda a distinguirlos.',
  ],
  'edu.startTitle': 'Cómo orientarte al empezar',
  'edu.startBody': [
    'Identifica el compuesto y su presentación (los mg del vial). Cada uno se estudia en rangos de dosis distintos.',
    'Reconstituye con agua bacteriostática. Nuestra calculadora te dice cuánta agua mezclar y cuántas rayitas jalar en la jeringa.',
    'Consulta la literatura antes que cualquier foro. La sección de abajo enlaza a revistas revisadas por pares y registros de ensayos.',
  ],
  'edu.startCta': 'Abrir la calculadora',
  'edu.libTitle': 'Literatura de investigación',
  'edu.libIntro': 'Selección de fuentes revisadas por pares y bases de datos públicas para leer directamente a los estudios. Se abren en una pestaña nueva.',
  // Galería de las 7 fotos que salieron de la portada (Christián, 2026-07-31).
  'edu.photosTitle': 'Así Se Ve El Trabajo De Laboratorio',
  'edu.photosIntro': 'Cuadros del laboratorio donde se fabrican nuestros péptidos y del trabajo analítico que hay detrás de cada lote.',
  'edu.libNote': 'Enlaces a sitios externos (revistas y organismos científicos). Exygen Labs no es autor de estos trabajos y los ofrece solo con fines educativos.',
  'edu.cat.metabolic': 'Metabólicos y control de peso (GLP-1)',
  'edu.cat.repair': 'Reparación y recuperación de tejido',
  'edu.cat.skin': 'Piel y longevidad',
  'edu.cat.databases': 'Bases de datos para buscar tú mismo',
  'nf.title': 'Esta página se nos evaporó',
  'nf.body': 'La dirección que buscas no existe o cambió. Busca un péptido o vuelve a lo importante.',
  'nf.searchPlaceholder': 'Busca un péptido…',
  'nf.searchBtn': 'Buscar',
  'nf.home': 'Inicio',
  'nf.catalog': 'Catálogo',
  'nf.calc': 'Calculadora',
  'nf.ruo': 'Todos los productos son solo para uso en investigación (RUO).',
  'calc.title': 'Calculadora de reconstitución',
  'calc.subtitle': 'Elige el péptido y tu dosis; la calculadora te dice con cuánta agua mezclar y cuántas rayitas jalar. La unidad (mg o mcg) se ajusta sola.',
  'calc.modeSuggest': 'Sugiéreme el agua',
  'calc.modeKnown': 'Ya sé mi agua',
  'calc.step1': '1. Elige tu péptido (obligatorio)',
  'calc.reset': 'Reiniciar',
  'calc.copy': 'Copiar',
  'calc.link': 'Enlace',
  'calc.pdf': 'PDF',
  'calc.copied': 'Cálculo copiado',
  'calc.linkCopied': 'Enlace copiado',
  'calc.copyFail': 'No se pudo copiar',
  'calc.searchPlaceholder': 'Escribe para buscar…',
  'calc.noResults': 'Sin resultados. Revisa el nombre.',
  'calc.pickFirst': 'Elige un péptido arriba para empezar.',
  'calc.product': 'Péptido (opcional)',
  'calc.productPlaceholder': 'Elige un producto para autocompletar…',
  'calc.vial': 'Presentación de tu vial',
  'calc.water': 'Agua bacteriostática que agregas',
  'calc.dose': 'Dosis que quieres aplicar',
  'calc.refNote': 'Punto de partida de referencia (RUO). Ajústalo a tu protocolo.',
  'calc.lvlBasic': 'Inicial',
  'calc.lvlTypical': 'Típica',
  'calc.lvlAdvanced': 'Avanzada',
  'calc.mcgDisabled': 'Este péptido se dosifica en mg.',
  'calc.syringe': 'Tu jeringa',
  'calc.draw': 'Jala en la jeringa',
  'calc.addWater': 'Agrega esta agua',
  'calc.ofWater': 'de agua',
  'calc.thenEachDose': 'Y cada dosis serán',
  'calc.otherWaters': 'Otras opciones (toca para usarla):',
  'calc.units': 'rayitas',
  'calc.inSyringe': 'en tu jeringa',
  'calc.dragHint': 'Arrastra la jeringa o ajusta:',
  'calc.overfillTitle': 'No cabe en esta jeringa.',
  'calc.overfillDetail': 'Necesitas jalar {{necesita}} mL y la jeringa aguanta {{cabe}} mL.',
  'calc.peso.title': 'Convertidor por peso corporal',
  'calc.peso.body': 'Mucha literatura da la dosis en microgramos por kilo. Aquí pones tu peso y los mcg/kg del estudio, y te decimos el total — para que no se te pase un cero.',
  'calc.peso.kg': 'Peso (kg)',
  'calc.peso.porKg': 'Dosis (mcg/kg)',
  'calc.peso.total': 'Dosis total',
  'calc.peso.hint': 'Llena los dos campos.',
  'calc.peso.ruo': 'Es una multiplicación, no una recomendación: el número que pongas sale de tu fuente, no de nosotros. Material de uso exclusivo en investigación.',
  'calc.formulas.title': 'Las fórmulas, por si quieres hacerlas a mano',
  'calc.formulas.f1': 'Concentración (mg/mL) = miligramos del vial ÷ mililitros de agua',
  'calc.formulas.f2': 'Mililitros a jalar = dosis (mg) ÷ concentración (mg/mL)',
  'calc.formulas.f3': 'Rayitas (jeringa U-100) = mililitros a jalar × 100',
  'calc.formulas.nota': 'Ejemplo: vial de 10 mg con 2 mL de agua = 5 mg/mL. Una dosis de 0.5 mg son 0.1 mL, o sea 10 rayitas en una jeringa de insulina U-100.',
  'calc.faq.title': 'Preguntas que nos hacen seguido',
  'calc.faq.reconstituir.q': '¿Cómo se reconstituye un péptido liofilizado?',
  'calc.faq.reconstituir.a': 'Se le agrega agua bacteriostática, despacio y escurriendo por la pared del vial — nunca a chorro sobre el polvo. Luego se gira suave entre los dedos hasta que se disuelva. No se agita: la espuma y el golpeteo maltratan la molécula.',
  'calc.faq.rayitas.q': '¿Cuántas rayitas son mi dosis?',
  'calc.faq.rayitas.a': 'En una jeringa de insulina U-100 cada rayita es 0.01 mL. Divide tu dosis entre la concentración para saber los mililitros y multiplica por 100. La calculadora de arriba te lo hace y te dibuja la jeringa.',
  'calc.faq.agua.q': '¿Cuánta agua le pongo?',
  'calc.faq.agua.a': 'La que haga que tu dosis caiga en una lectura cómoda de la jeringa: ni tan poquita que sean dos rayitas, ni tanta que no quepa. Entre 1 y 5 mL es lo normal. Arriba puedes pedir "sugiéreme el agua" y te da el número.',
  'calc.faq.guardar.q': '¿Cómo lo guardo ya reconstituido?',
  'calc.faq.guardar.a': 'En refrigeración (2-8 °C), tapado y sin luz. El agua bacteriostática trae conservador y por eso permite varias extracciones del mismo vial. Sin abrir y en polvo, el vial aguanta mucho más: consulta la ficha de tu producto.',
  'calc.faq.jeringa.q': '¿Qué jeringa necesito?',
  'calc.faq.jeringa.a': 'La de insulina U-100 es la más común en México y la más fácil de leer para dosis chicas. Si tu dosis no cabe, la calculadora te avisa y te dice cuántos mililitros necesitas para escoger una más grande.',
  'calc.overfill': 'Esa dosis no cabe en esta jeringa: usa menos agua o una jeringa más grande.',
  'calc.tooSmallTitle': 'Dosis demasiado chica para este vial',
  'calc.tooSmallBody': 'Ni con la máxima agua se puede medir bien en la jeringa. Este vial es para dosis mayores; usa un vial más chico o sube la dosis.',
  'calc.tooSmallInline': '⚠ Menos de 2 rayitas: casi imposible de medir con precisión.',
  'calc.tooBigTitle': 'Dosis demasiado grande para esta jeringa',
  'calc.tooBigBody': 'Ni con poca agua cabe en una sola jeringa. Usa una jeringa más grande o divide la dosis.',
  'calc.conc': 'Concentración',
  'calc.dosesPerVial': 'Dosis por vial',
  'calc.doses': 'dosis',
  'calc.dura.label': 'Te dura',
  'calc.dura.weeks': 'semanas',
  'calc.dura.days': 'días',
  'calc.dura.avisoTitle': 'Este vial te rinde para mucho tiempo.',
  'calc.dura.avisoBody': 'Con la dosis que tienes puesta, tu vial de {{vial}} mg te alcanza para {{dura}}. Ya mezclado con agua, lo recomendable es usarlo dentro de {{vida}}, guardado en el refrigerador.',
  'calc.dura.avisoSugerido': 'Para no tenerlo mezclado más tiempo del recomendado, te acomoda mejor el vial de {{mg}} mg.',
  'calc.dura.avisoPorciones': 'De este producto no hay una presentación más chica. Apunta la fecha en que lo mezcles y guíate por ese plazo.',
  'calc.dura.fuente': 'De dónde sale ese plazo: {{fuente}}',
  // Qué es ese plazo, en cristiano. Va en los dos sentidos a propósito: ni
  // "se echa a perder" (que espanta y no está demostrado) ni "el péptido está
  // perfecto" (que tampoco lo está: nadie lo midió en refrigeración).
  'calc.dura.porQue': 'Ese plazo es el que se le garantiza al vial de seguir limpio por dentro una vez que el tapón recibe el primer piquete. De la fuerza del péptido guardado en frío nadie ha publicado un número, así que nos guiamos por el plazo del vial, que sí lo tiene.',
  'calc.dura.avisoBodyPlan': 'Siguiendo el plan de abajo, tu vial de {{vial}} mg te alcanza para {{dura}}. Ya mezclado con agua, lo recomendable es usarlo dentro de {{vida}}, guardado en el refrigerador.',
  // El plan de subida (la escalera). En llano: nunca se escribe "titulación".
  'calc.plan.title': 'Tu plan, semana por semana',
  'calc.plan.intro': 'No te quedas siempre en la misma cantidad. Se empieza con poquito, el cuerpo se va acostumbrando y cada cierto tiempo se sube un escalón.',
  'calc.plan.hint': 'siguiendo el plan de abajo',
  'calc.plan.semana': 'Semana {{n}}',
  'calc.plan.semanas': 'Semanas {{a}} a {{b}}',
  'calc.plan.desdeLa': 'De la semana {{a}} en adelante',
  'calc.plan.teQuedas': 'aquí te quedas',
  'calc.plan.dura': 'Siguiendo este plan, tu vial de {{vial}} mg te alcanza para {{dura}}.',
  'calc.plan.duraCorto': 'Siguiendo este plan, tu vial de {{vial}} mg te alcanza para {{dura}}: llegas a los {{dosis}} y ahí se acaba. Si quieres completar el plan, te acomoda una presentación más grande.',
  'calc.plan.medico': 'Lo ideal es que un médico decida contigo cuándo subir, con tus análisis en la mano. Este calendario es una referencia de investigación (RUO), no una pauta médica.',
  'calc.enterValues': 'Llena los datos de la izquierda y aquí verás el resultado.',
  'calc.disclaimer': 'Solo para uso en investigación (RUO). No es consejo médico ni de dosificación para humanos o animales. Verifica siempre tus cálculos.',
  'calc.browse': 'Ver catálogo de péptidos',

  'catalog.category': 'Categoría',
  'catalog.allCategories': 'Todas',
  'catalog.maxPrice': 'Precio máximo',
  'catalog.upTo': 'Hasta {{price}}',
  'catalog.inStockOnly': 'Solo disponibles',
  'catalog.clearFilters': 'Limpiar filtros',
  'catalog.resultsFor': 'Resultados: "{{search}}"',
  'catalog.title': 'Catálogo de péptidos',
  'catalog.ruoLine': 'Todos los productos son para uso en investigación (RUO).',
  'catalog.searchPlaceholder': 'Buscar en el catálogo...',
  'catalog.filters': 'Filtros',
  'catalog.sort.relevance': 'Relevancia',
  'catalog.sort.nameAsc': 'Nombre A-Z',
  'catalog.sort.nameDesc': 'Nombre Z-A',
  'catalog.sort.category': 'Categoría A-Z',
  'catalog.sort.priceAsc': 'Precio: menor a mayor',
  'catalog.sort.priceDesc': 'Precio: mayor a menor',
  'catalog.sort.newest': 'Novedades',
  'catalog.empty': 'No se encontraron productos con esos filtros.',
  'catalog.productCount': '{{count}} productos',

  'product.notFound': 'Producto no encontrado.',
  'product.backToCatalog': 'Volver al catálogo',
  'product.ruoWarning': 'Solo para uso en investigación (RUO). No destinado a diagnóstico, tratamiento, cura o prevención de enfermedades.',
  'product.photoNote': 'La cantidad en la foto es solo ilustrativa; se despacha la presentación (mg) que elijas.',
  'product.brandPhotoNote': 'Imagen ilustrativa de nuestros viales. La etiqueta que recibes corresponde al producto y la presentación que elijas.',
  'product.coaVerified': 'Pureza HPLC',
  'product.new': 'Nuevo',
  'product.purityLine': 'Pureza {{purity}}',
  'product.volumePricing': 'Precio por volumen: {{tiers}}',
  'product.volumeNudge': 'Llévate 3 o más y ahorra 12%',
  'product.cryptoDiscount': 'Paga en cripto y ahorra 5% adicional',
  'product.zoomOpen': 'Ver la foto en grande',
  'product.zoomIn': 'Acercar',
  'product.zoomOut': 'Alejar',
  'product.zoomClose': 'Cerrar',
  'product.safeCheckout': 'Compra segura',
  'product.safeCheckoutMethods': 'Tarjeta, SPEI, OXXO y criptomonedas. No guardamos tu número de tarjeta.',
  'product.volumeApplied': '✓ 12% de descuento por volumen',
  'product.outOfStock': 'Agotado',
  'product.inStock': 'En stock ({{stock}} disponibles)',
  'product.addToCart': 'Agregar al carrito',
  'product.viewCoa': 'Certificado de tu lote, en digital al comprar',
  'product.coaTitle': 'Certificado de Análisis (COA)',
  'product.coaHelp': 'Cada lote se analiza por HPLC y tiene su propio COA. Después de tu compra te entregamos, en digital, el PDF del lote que te corresponde.',
  'product.downloadPdf': 'Descargar PDF',
  'product.fastShipping': 'Envío 3–5 días',
  'product.discreetPackaging': 'Empaque discreto',
  'product.tabs.description': 'Descripción',
  'product.tabs.specs': 'Especificaciones',
  'product.tabs.storage': 'Almacenamiento',
  'product.tabs.shipping': 'Envíos',
  'product.shippingText': 'Realizamos envíos a todo México. Envío estándar (3 a 5 días hábiles): $250, incluido en compras desde $2,500. Envío express (1 a 2 días hábiles): $150 adicionales; gratis cuando tu pedido califica. Empaque discreto y con control de temperatura cuando aplica.',
  'product.related': 'Productos relacionados',
  'product.card.purity': 'Pureza {{purity}}',
  'product.card.add': 'Agregar',
  'product.card.view': 'Ver',
  'product.card.inStock': 'En stock',

  'cart.emptyTitle': 'Tu carrito está vacío',
  'cart.emptyBody': 'Explora nuestro catálogo de péptidos de investigación.',
  'cart.title': 'Tu carrito',
  'cart.remove': 'Quitar',
  'cart.netPrice': 'Precio neto — este producto no participa en descuentos',
  'cart.summary': 'Resumen',
  'cart.freeShippingLine': 'El envío se cotiza y se cobra por separado según tu zona',
  'cart.shippingTBD': 'Por cotizar',
  'cart.plusShipping': 'Más envío (se cotiza por separado)',
  'cart.cryptoHint': 'Paga en cripto y ahorra 5% adicional.',
  'cart.checkout': 'Finalizar compra',
  'cart.keepShopping': 'Seguir comprando',
  'cart.codigo.invalido': 'Código no válido',
  // El servidor no contestó: no sabemos si el código vale o no. Decirle
  // "no válido" sería mentirle. Ver lib/api.js -> esCaidaDeApi.
  'cart.codigo.mantenimiento': 'Estamos En Mantenimiento; No Pudimos Verificar Tu Código. Intenta De Nuevo En Unos Minutos',

  'checkout.empty': 'Tu carrito está vacío.',
  'checkout.armandoCarrito': 'Armando tu carrito con la cotización…',
  'cart.cotizacionCargada': 'Tu cotización ya está en el carrito',
  'checkout.title': 'Finalizar compra',
  'country.searchPlaceholder': 'Busca un país o su lada (+52)',
  'country.noMatches': 'Ningún país con ese nombre.',
  'verify.adopted': 'Encontramos {{count}} compras anteriores con tu correo y ya están en tu cuenta.',
  'verify.adoptedOne': 'Encontramos una compra anterior con tu correo y ya está en tu cuenta.',
  'checkout.contactTitle': 'Datos de contacto y envío',
  'checkout.fullName': 'Nombre completo *',
  'checkout.email': 'Correo electronico *',
  'checkout.phone': 'Teléfono *',
  'checkout.address': 'Dirección (calle y número) *',
  'checkout.address2': 'Interior, departamento o referencia (opcional)',
  'checkout.address2Placeholder': 'Ej. Int. 4B, entre Reforma e Insurgentes',
  'checkout.statePlaceholder': 'Elige tu estado',
  'checkout.countryMexico': 'México · único destino',
  'checkout.stateSearchPlaceholder': 'Escribe tu estado',
  'checkout.stateNoMatches': 'Ningún estado con ese nombre.',
  'checkout.prefilled': 'Usamos los datos de tu última compra · edítalos si cambiaron.',
  'checkout.prefilledCotizacion': 'Ya pusimos tus datos, los de tu cotización · edita lo que quieras.',
  'checkout.legalNote': 'Al confirmar tu pedido reafirmas que eres mayor de 21 años y que los productos son exclusivamente para investigación (RUO). Aplican:',
  'checkout.city': 'Ciudad / Municipio',
  'checkout.state': 'Estado',
  'checkout.postalCode': 'Código postal',
  'checkout.country': 'Pais *',
  'checkout.notes': 'Notas (opcional)',
  'checkout.paymentTitle': 'Método de pago',
  'checkout.paymentNote': 'Los métodos se muestran como propuesta (sin procesamiento real por ahora).',
  'checkout.orderSummary': 'Resumen del pedido',
  'checkout.placeOrder': 'Realizar pedido',
  'checkout.securePayment': 'Pago seguro',
  'checkout.coaByLot': 'Pureza HPLC',
  'checkout.toast.envio': 'Elige tu tipo de envío: estándar o express.',
  'checkout.shipping.porElegir': 'Elige arriba',
  'checkout.toast.cp': 'Escribe un código postal válido (5 dígitos).',
  'checkout.toast.pago': 'Elige cómo quieres pagar.',
  'checkout.toast.required': 'Completa los campos obligatorios',
  'checkout.toast.phone': 'El teléfono debe tener 10 digitos (ej. (55) 1234-5678)',
  'checkout.toast.success': 'Pedido realizado con exito',
  'checkout.toast.error': 'Error al crear el pedido',
  // Envío cotizado en el momento (Skydropx). Solo se ven cuando el servidor
  // enciende la cotización; hoy está apagada y estas claves no se pintan.
  'checkout.shipping.pick': 'Elige cómo quieres que te llegue',
  'checkout.shipping.standard': 'Envío Estándar',
  'checkout.shipping.standardDays': '3 a 5 días hábiles',
  'checkout.shipping.express': 'Envío Express',
  'checkout.shipping.expressDays': '1 a 2 días hábiles',
  'checkout.shipping.included': 'Incluido',
  'checkout.expressBadge': 'Envío Express Disponible',
  'checkout.shipping.soloDisponible': 'Los plazos aplican a lo disponible en bodega; lo sobre pedido tarda ~1 semana.',
  'checkout.shipping.expressGratis': '¡Buenas noticias! Tu pedido califica para envío express gratis.',
  'checkout.shipping.askZip': 'Escribe tu código postal y te decimos cuánto cuesta el envío.',
  'checkout.shipping.loading': 'Consultando a la paquetería…',
  'checkout.shipping.days': '{{days}} días hábiles',
  'checkout.shipping.dayOne': '1 día hábil',
  'checkout.shipping.free': 'Gratis',
  'checkout.shipping.freeNote': 'Tu pedido llega con envío por cuenta de la casa.',
  'checkout.shipping.none': 'No tenemos cobertura para ese código postal. Escríbenos y lo resolvemos contigo.',
  'checkout.shipping.failed': 'La paquetería no respondió. Tu pedido se puede hacer igual y te cotizamos el envío aparte.',

  'auth.login.sideTitle': 'Tu fuente confiable de péptidos de investigación en México',
  'auth.login.bullet1': 'Pureza verificada por HPLC',
  'auth.login.bullet2': 'Envío nacional 3–5 días',
  'auth.login.bullet3': 'Historial de pedidos y soporte experto',
  'auth.login.title': 'Iniciar sesión',
  'auth.login.subtitle': 'Accede a tu cuenta de Exygen Labs',
  'auth.email': 'Correo electronico',
  'auth.password': 'Contraseña',
  'auth.login.submit': 'Iniciar sesión',
  'auth.microsoft.cta': 'Continuar con Outlook',
  'auth.microsoft.consentNote': 'Microsoft ya confirmó tu correo. Solo falta que aceptes nuestras condiciones; las dos primeras son obligatorias.',
  'auth.google.cta': 'Continuar con Google',
  'common.error': 'Algo salio mal. Intenta de nuevo.',
  'passkey.hintCreate': 'Si aún no tienes tu llave de acceso, créala entrando con tu contraseña, en Mi Cuenta → Perfil.',
  'passkey.loginCta': 'Entrar con llave de acceso',
  'passkey.loginFailed': 'No se pudo entrar con la llave de acceso.',
  'passkey.title': 'Llaves de acceso',
  'passkey.explain': 'Entra con tu huella, tu cara o el candado de tu dispositivo, sin contraseña. Es la forma mas segura y rápida de entrar.',
  'passkey.addCta': 'Agregar llave de acceso',
  'passkey.defaultName': 'Llave de acceso',
  'passkey.added': 'Llave de acceso creada.',
  'passkey.addFailed': 'No se pudo crear la llave de acceso.',
  'passkey.err.cancelled': 'Se canceló o tardó demasiado. Intenta de nuevo con tu huella o rostro.',
  'passkey.err.exists': 'Este equipo ya tiene una llave registrada para tu cuenta.',
  'passkey.err.unsupported': 'Este equipo no tiene Touch ID / Face ID disponible.',
  'passkey.removed': 'Llave eliminada.',
  'passkey.remove': 'Eliminar llave',
  'passkey.unsupported': 'Tu navegador no soporta llaves de acceso.',
  'totp.title': 'Código de verificacion',
  'totp.body': 'Tu cuenta tiene segundo factor. Escribe el código de 6 digitos de tu app autenticadora.',
  'totp.submit': 'Verificar',
  'totp.cardTitle': 'Segundo factor (2FA)',
  'totp.on': 'Activo',
  'totp.explain': 'Obligatorio para administradores: además de la contraseña, un código de 6 digitos de tu app autenticadora (Google Authenticator, 1Password, etc.).',
  'totp.setupCta': 'Activar 2FA',
  'totp.scan': 'Escanea este QR con tu app autenticadora y escribe el código que te muestre.',
  'totp.manual': 'O captura el secreto a mano',
  'totp.confirmCta': 'Confirmar',
  'totp.disableCta': 'Desactivar',
  'totp.enabled': '2FA activado. Se pedira el código al entrar.',
  'totp.disabled': '2FA desactivado.',
  'auth.google.divider': 'o',
  'auth.resend.signupTitle': 'Crea tu cuenta en Exygen Labs',
  'auth.resend.loginTitle': 'Entra a Exygen Labs',
  'auth.resend.haveAccount': '¿Ya tienes cuenta?',
  'auth.resend.noAccount': '¿No tienes cuenta?',
  'auth.google.consentTitle': 'Antes de crear tu cuenta',
  'auth.google.consentNote': 'Google ya confirmo tu correo. Solo falta que aceptes nuestras condiciones; las dos primeras son obligatorias.',
  'loyalty.title': 'Mis puntos',
  'loyalty.unit': 'puntos',
  'loyalty.cardNote': '1 punto = $1 al canjear',
  'loyalty.explain': 'El 3% de cada compra pagada vuelve como puntos cuando confirmamos tu pago. Los canjeas como dinero en tu siguiente compra (no aplican al envío).',
  'loyalty.empty': 'Aun no tienes movimientos. Se generan con tu primera compra pagada.',
  'loyalty.line': 'Puntos canjeados',
  'loyalty.use': 'Usar mis {{points}} puntos en esta compra',
  'loyalty.useNote': 'Se descuentan del total de la mercancia; 1 punto = $1. Si el pedido se cancela, se devuelven.',
  'loyalty.type.earn': 'Puntos ganados',
  'loyalty.type.redeem': 'Canje en compra',
  'loyalty.type.refund': 'Devolucion por cancelacion',
  'loyalty.type.revoke': 'Ajuste por cancelacion',
  'auth.login.loading': 'Ingresando...',
  'auth.login.noAccount': '¿No tienes cuenta?',
  'auth.login.register': 'Registrate',
  'auth.toast.welcome': 'Bienvenido de nuevo',
  'auth.toast.loginError': 'Error al iniciar sesión',
  // El servidor no contestó (caída/intermitencia). No es que la cuenta esté
  // mal: es que no hay a quién preguntarle. Ver lib/api.js -> esCaidaDeApi.
  'auth.toast.mantenimiento': 'Estamos En Mantenimiento; Intenta De Nuevo En Unos Minutos',
  'aviso.intermitencia': 'Estamos Teniendo Intermitencia En El Servidor; El Catálogo Sigue Disponible',
  'auth.register.title': 'Crear cuenta',
  'auth.register.subtitle': 'Unete para dar seguimiento a tus pedidos',
  'auth.name': 'Nombre completo',
  'auth.register.submit': 'Crear cuenta',
  'auth.register.loading': 'Creando...',
  'auth.register.haveAccount': '¿Ya tienes cuenta?',
  'auth.register.loginLink': 'Inicia sesión',
  'auth.toast.passwordLength': 'La contraseña debe tener al menos 6 caracteres',
  'auth.toast.created': 'Cuenta creada con exito',
  'auth.toast.registerError': 'Error al registrarse',

  'account.title': 'Mi Cuenta',
  'account.signOut': 'Salir',
  'account.ordersTab': 'Mis Pedidos',
  'account.profileTab': 'Perfil',
  'dash.collapse': 'Ocultar menú',
  'dash.expand': 'Mostrar menú',
  // Categorías del menú de los tableros (cliente y distribuidor).
  'dash.group.business': 'Mi Negocio',
  'dash.group.purchases': 'Mis Compras',
  'dash.group.resources': 'Recursos',
  'dash.group.account': 'Mi Cuenta',
  'dash.difusionLink': 'Panel De Difusión',
  // Las tarjetas de números de los tableros son accesos directos: se tocan y
  // llevan a sus datos. Esto es lo que oye un lector de pantalla al final del
  // nombre de la tarjeta, para que se sepa que ahí se puede tocar.
  'dash.card.open': 'Ver Detalle',
  'account.pointsTab': 'Mis Puntos',
  'loyalty.historyTitle': 'Historial De Puntos',
  'account.noOrders': 'Aun no tienes pedidos.',
  'account.exploreCatalog': 'Explorar catálogo',
  'account.detail': 'Detalle',
  'account.orderTitle': 'Pedido {{number}}',
  'account.shipTo': 'Envío a: {{address}}, {{city}} {{state}} {{postalCode}}',
  // Vuelta a los datos de pago (CLABE de SPEI, ficha de OXXO) desde Mis Pedidos.
  // Antes no había enlace y había que teclear la URL del pedido a mano.
  'account.seePaymentDetails': 'Ver Datos Para Pagar',
  // La ficha de OXXO, recuperable. Antes se perdía al cerrar la pestaña.
  'oxxo.title': 'Tu ficha de pago OXXO',
  'oxxo.instructions': 'Abre tu ficha, muéstrala en la caja de cualquier OXXO y paga en efectivo. En cuanto se refleje el pago te avisamos por correo.',
  'oxxo.openVoucher': 'Abrir Mi Ficha De Pago',
  'account.name': 'Nombre',
  'account.email': 'Correo',
  'account.accountType': 'Tipo de cuenta',
  'account.admin': 'Administrador',
  'account.customer': 'Cliente',

  'spei.title': 'Paga por transferencia SPEI',
  'spei.instructions': 'Haz la transferencia por el monto exacto desde tu banca en linea. Tu pedido se aparta al confirmarse el pago.',
  'spei.beneficiary': 'Beneficiario',
  'spei.bank': 'Banco',
  'spei.amount': 'Monto',
  'spei.reference': 'Referencia / concepto',
  'spei.copied': 'Copiado',
  'spei.confirmNote': 'Usa el número de pedido como concepto. En cuanto se refleje el pago te confirmamos por correo.',
  'order.received': 'Pedido recibido!',
  'order.receivedBody': 'Tu pedido {{number}} fue registrado correctamente.',
  // La confirmación no pudo traer el detalle del pedido. Se distingue la caída
  // del servidor (esCaidaDeApi) de un pedido que de plano no se pudo abrir.
  'order.detalleCaida': 'Estamos En Mantenimiento; No Pudimos Cargar El Detalle De Tu Pedido. Recarga Esta Página En Unos Minutos Para Ver Las Instrucciones De Pago.',
  'order.detalleError': 'No pudimos cargar el detalle de este pedido. Si el problema sigue, escríbenos con tu número de pedido.',
  'order.paymentMethod': 'Método de pago',
  'order.noteTitle': 'Nota:',
  'order.noteBody': 'Los métodos de pago se muestran como propuesta. Aun no se procesa el cobro en linea; nuestro equipo te contactara para coordinar el pago y el envío.',
  'order.viewMyOrders': 'Ver mis pedidos',

  // EL RASTREO, DENTRO DE NUESTRA PÁGINA (Christián, 2026-07-31). El iframe a FedEx no
  // se puede —mandan `x-frame-options: SAMEORIGIN`—, así que le pedimos los eventos a
  // su API y los pintamos aquí. Ver RastreoEnvio.js.
  'tracking.title': 'Dónde va tu pedido',
  'tracking.preparing': 'Estamos preparando tu paquete. En cuanto salga, aquí aparece la guía.',
  'tracking.step.recibido': 'Pedido recibido',
  'tracking.step.transito': 'En camino',
  'tracking.step.reparto': 'En reparto',
  'tracking.step.entregado': 'Entregado',
  'tracking.eta': 'Llegada estimada: {{date}}',
  'tracking.history': 'Historial del envío',
  // Guías compradas fuera de plataforma (la de Aidee se compró en el mostrador):
  // de ésas no hay eventos y se dice, en vez de dejar un hueco que parece falla.
  'tracking.noDetail': 'El detalle del rastreo aún no está disponible para esta guía. Con tu número de guía puedes consultarla directo en el sitio de la paquetería.',
  'tracking.issue': 'La paquetería reportó un problema con este envío. Escríbenos con tu número de pedido y lo revisamos contigo.',
  'tracking.carrierSite': 'Ver En El Sitio De La Paquetería',
  // El carrier reporta en INGLÉS («Picked up»). Como el servidor ya normaliza el
  // código del evento, se prefiere NUESTRO texto y sólo se cae al del carrier cuando
  // el código no lo conocemos. Ver RastreoEnvio.js.
  'tracking.event.created': 'Guía generada',
  'tracking.event.picked_up': 'Recolectado por la paquetería',
  'tracking.event.in_transit': 'En tránsito',
  'tracking.event.last_mile': 'En ruta de entrega',
  'tracking.event.delivery_attempt': 'Intento de entrega',
  'tracking.event.delivered_to_branch': 'Disponible en sucursal',
  'tracking.event.delivered': 'Entregado',
  'tracking.event.exception': 'Incidencia reportada',
  'tracking.event.in_return': 'En devolución',
  'tracking.event.canceled': 'Envío cancelado',
  'tracking.event.retained': 'Paquete retenido',

  'info.envios.title': 'Envíos y entregas',
  'info.envios.body': ['Enviamos a todo el territorio de la Republica Mexicana por FedEx aereo.', 'Despacho el mismo día: los pedidos realizados antes de las 5:00 pm se envian ese mismo día habil; después, al siguiente día habil.', 'Tiempo de entrega estimado: 3 a 5 días habiles (lunes a viernes, sin contar festivos). Algunas zonas pueden variar.', 'Costo del envío estándar: $250. Incluido en compras desde $2,500 (ya con descuento). Envío express (1 a 2 días hábiles): $150 adicionales; gratis cuando tu pedido califica.', 'Recibiras el número de rastreo por correo automaticamente en cuanto se genere la guia.', 'No realizamos envíos internacionales ni usamos servicios de reenvio.', 'Verifica cuidadosamente tu dirección al finalizar la compra. Los cambios de dirección solo se pueden solicitar antes de que el pedido sea enviado.'],
  'info.devoluciones.title': 'Devoluciones',
  'info.devoluciones.body': ['Por la naturaleza de los productos (uso exclusivo en investigación), todas las ventas son finales.', 'Si tu producto llega danado, contactanos lo antes posible con tu número de pedido y fotos claras del empaque y del producto para poder ayudarte.', 'Escribenos a hola@exygenlabs.com para cualquier incidencia con tu envío.'],
  'info.calidad.title': 'Calidad',
  'info.calidad.body': ['Cada lote de nuestros péptidos se analiza por HPLC (y MS cuando aplica) para verificar su pureza.', 'Cada lote queda registrado con su propio certificado de análisis.', 'Después de tu compra te entregamos, en digital, el certificado del lote que te corresponde: no tienes que pedirlo.', 'La pureza típica de nuestro catálogo es >= 99%.'],
  'info.terminos.title': 'Términos de servicio y aviso RUO',
  'info.privacidad.title': 'Política de privacidad',
  'info.privacidad.body': ['Recopilamos solo los datos necesarios para operar tu cuenta y tus pedidos: nombre, correo, teléfono y direcciones de envío/facturacion.', 'NUNCA guardamos números de tarjeta: los pagos se procesan siempre con el proveedor de pago correspondiente.', 'No vendemos ni compartimos tus datos con terceros; solo los usamos para procesar pedidos, enviarte confirmaciones y darte soporte.', 'Usamos almacenamiento local del navegador para tu sesión y tu carrito.', 'Puedes pedir la correccion o eliminacion de tus datos escribiendo a hola@exygenlabs.com.'],
  'info.terminos.body': ['Todos los productos vendidos por Exygen Labs son exclusivamente para uso en investigación y desarrollo (RUO).', 'No están destinados al consumo humano ni animal, ni para diagnóstico, tratamiento, cura o prevención de enfermedades.', 'Al realizar una compra, el cliente declara ser un investigador calificado y asume la responsabilidad del manejo y uso de los productos conforme a la normativa aplicable.', 'Exygen Labs no se hace responsable por el uso indebido de los productos.'],
  'info.defaultTitle': 'Información',
  'info.notFound': ['Página no encontrada.'],
  'info.backToCatalog': '← Volver al catálogo',

  'chat.quick.ruo': '¿Qué significa RUO?',
  'chat.quick.goal': 'Ayudame a elegir por objetivo de investigación',
  'chat.quick.shipping': 'Envíos y tiempos',
  'chat.quick.coa': '¿Cómo verifican la pureza?',
  'chat.quick.order': '¿Dónde va mi pedido?',
  'chat.initial': 'Hola, soy Exygen, el asistente de Exygen Labs. Puedo ayudarte a encontrar un péptido segun tu objetivo de investigación y a ubicar COA/lotes. En que te apoyo?',
  'chat.error': 'Lo siento, ocurrio un error. Intenta de nuevo.',
  'chat.open': 'Abrir asistente',
  'chat.close': 'Cerrar',
  'chat.send': 'Enviar',
  'chat.title': 'Asistente Exygen',
  'chat.online': 'En linea · responde en segundos',
  'chat.responds': 'Suele responder en unos segundos',

  // Bienvenida del asistente: burbuja + píldoras + cuadrícula de opciones.
  'chat.welcome.hi': '¡Hola! Soy el asistente de Exygen Labs.',
  'chat.welcome.canHelp': 'Puedo ayudarte con:',
  'chat.welcome.items': ['Información de productos', 'Precios', 'Envíos', 'Rastreo de pedidos', 'Pedidos'],
  'chat.welcome.how': '¿Cómo puedo ayudarte hoy?',

  'chat.opt.explore': 'Explorar Productos',
  'chat.opt.popular': 'Más Solicitados',
  'chat.opt.prices': 'Precios',
  'chat.opt.shipping': 'Envíos',
  'chat.opt.local': 'Entrega Local',
  'chat.opt.track': 'Rastrear Mi Pedido',
  'chat.opt.contact': 'Contactar Al Equipo',
  'chat.opt.whatsapp': 'Pedir Por WhatsApp',

  // Lo que cada botón le escribe al asistente.
  'chat.ask.explore': '¿Qué productos tienen disponibles?',
  'chat.ask.popular': '¿Cuáles son sus productos más solicitados?',
  'chat.ask.prices': '¿Cuáles son sus precios?',
  'chat.ask.shipping': '¿Cómo funcionan los envíos y cuánto tardan?',
  'chat.ask.local': '¿Hacen entrega local?',
  'chat.ask.track': 'Quiero rastrear mi pedido',
  'chat.ask.contact': 'Quiero contactar al equipo',

  'chat.placeholder': 'Pregunta sobre productos, precios o envíos...',
  'chat.disclaimer': 'Respuestas informativas. Solo uso en investigación (RUO).',

  // ---------------------------------------------------------------------
  //  ASESOR DE NEGOCIO — el chat de adentro del panel (admin y distribuidores)
  // ---------------------------------------------------------------------
  // ⛔ Los textos del admin hablan de costos y proveedores; los del distribuidor
  // NO. Aun así, el candado no son estos textos: es el servidor, que arma el
  // contexto según el rol. Aquí sólo se ajusta lo que se le sugiere a cada quien.
  'negocio.chat.tab': 'Asesor De Negocio',
  'negocio.chat.title': 'Asesor De Negocio',
  'negocio.chat.subtitleDist': 'Pregúntale de tu negocio: cotizaciones, cuánto ganas con un descuento y qué ofrecerle a un cliente. Conoce el catálogo con precios, tu comisión y tus topes.',
  'negocio.chat.subtitleAdmin': 'Tu asistente de negocio: cotizaciones, márgenes, costos, proveedores y qué conviene ofrecer. Ve todo el catálogo con costos y ROI.',
  'negocio.chat.hi': '¿En qué te ayudo?',
  'negocio.chat.helpDist': 'Conozco el catálogo con precios, tu comisión, tu descuento máximo y las reglas del canal. No tengo los números internos de la casa.',
  'negocio.chat.helpAdmin': 'Conozco el catálogo con precios, los costos de compra, a quién le compramos y la última foto del motor de precios.',
  'negocio.chat.ask.quote': 'Ármame una cotización de 5 piezas de Retatrutida',
  'negocio.chat.ask.earn': '¿Cuánto gano si vendo $10,000 con 20% de descuento?',
  'negocio.chat.ask.recommend': '¿Qué le recomiendo a un cliente que busca bajar de peso?',
  'negocio.chat.ask.rules': '¿Cuáles son las reglas de mi comisión y mis descuentos?',
  'negocio.chat.ask.margin': '¿Qué productos me dejan menos margen?',
  'negocio.chat.ask.supplier': '¿A quién le compro la Retatrutida y a cuánto?',
  'negocio.chat.placeholder': 'Escribe tu pregunta de negocio...',
  'negocio.chat.send': 'Enviar',
  'negocio.chat.error': 'No pude responder en este momento. Intenta de nuevo en un minuto.',
  'negocio.chat.disclaimer': 'El asistente puede equivocarse. El precio y la comisión que valen son los del pedido.',
  'negocio.chat.nuevo': 'Nuevo Chat',
  'negocio.chat.anteriores': 'Chats Anteriores',
  'negocio.chat.sinAnteriores': 'Aún no hay chats anteriores.',
  'negocio.chat.sinTitulo': 'Chat sin título',
  'negocio.chat.memoriaAviso': 'Este chat ya usó casi toda su memoria. Abre uno nuevo para que el asesor no pierda el hilo.',
  'negocio.chat.memoriaLlena': 'El asesor ya está olvidando los mensajes más viejos de este chat.',
  'negocio.chat.buscar': 'Buscar en tus chats...',
  'negocio.chat.sinResultados': 'No hay chats que coincidan.',
  'negocio.chat.anio': 'Año',
  'negocio.chat.mes': 'Mes',
  'negocio.chat.coincidencias': '{{n}} coincidencias',
  'negocio.chat.renombrar': 'Renombrar Chat',
  'negocio.chat.renombrarPregunta': 'Nuevo nombre del chat (déjalo vacío para volver al título automático):',
  'negocio.chat.archivar': 'Archivar Chat',
  'negocio.chat.archivarConfirma': '¿Archivar este chat? Quedará en solo lectura.',
  'negocio.chat.archivadoBanner': 'Este Chat Está Archivado',
  'negocio.chat.archivados': 'Archivados',
  'negocio.chat.errorArchivado': 'Este chat está archivado y ya no admite mensajes nuevos.',
  'negocio.chat.grupo.hoy': 'Hoy',
  'negocio.chat.grupo.ayer': 'Ayer',
  'negocio.chat.grupo.estaSemana': 'Esta Semana',
  'negocio.chat.grupo.semanaPasada': 'Semana Pasada',
  'negocio.chat.grupo.esteMes': 'Este Mes',

  // ---------------------------------------------------------------------
  //  COTIZADOR DE ENVÍOS — «¿cuánto cuesta mandar esto a tal código postal?»
  // ---------------------------------------------------------------------
  // ⛔ Las llaves `cotizadorEnvio.casa.*` son las ÚNICAS que hablan de lo que la
  // casa paga, y sólo se pintan en el Panel de Administración. El candado de
  // verdad no son estos textos: es el servidor, que ni siquiera se los manda al
  // distribuidor (ver `_solo_lo_del_distribuidor` en el backend).
  'cotizadorEnvio.title': 'Cotizador De Envíos',
  'cotizadorEnvio.subtitle': 'Pregunta cuánto cuesta mandar un pedido a un código postal, sin tener que armarlo. Te dice qué paqueterías hay, en cuántos días llegan y cuánto pagaría de envío tu cliente.',
  'cotizadorEnvio.casa.subtitle': 'Qué cuesta mandar un bulto a un código postal, sin pedido de por medio: las tarifas de cada paquetería, lo que se le cobraría al cliente y lo que absorbe la casa.',
  'cotizadorEnvio.destination': 'A Dónde Va',
  'cotizadorEnvio.country': 'País',
  'cotizadorEnvio.country.mx': 'México',
  'cotizadorEnvio.country.other': 'Otro País',
  'cotizadorEnvio.postalCode': 'Código Postal',
  'cotizadorEnvio.state': 'Estado',
  'cotizadorEnvio.city': 'Ciudad',
  'cotizadorEnvio.noCoverage': 'Fuera de México no hay cobertura: las paqueterías que tenemos contratadas sólo cubren la República Mexicana. Un envío internacional se cotiza aparte, a mano.',
  'cotizadorEnvio.what': 'Qué Se Manda',
  'cotizadorEnvio.mode.items': 'Por Productos',
  'cotizadorEnvio.mode.manual': 'Peso Y Medidas',
  'cotizadorEnvio.search': 'Busca un producto…',
  'cotizadorEnvio.searchHint': 'El peso lo calcula el servidor con el catálogo real; aquí sólo se dice qué va adentro.',
  'cotizadorEnvio.empty': 'Todavía no has agregado nada.',
  'cotizadorEnvio.remove': 'Quitar',
  'cotizadorEnvio.weight': 'Peso (kg)',
  'cotizadorEnvio.length': 'Largo (cm)',
  'cotizadorEnvio.width': 'Ancho (cm)',
  'cotizadorEnvio.height': 'Alto (cm)',
  'cotizadorEnvio.merchandise': 'Monto De La Compra',
  'cotizadorEnvio.merchandiseHint': 'Sirve para saber si el pedido alcanza el envío gratis. Déjalo en blanco si sólo quieres la tarifa.',
  'cotizadorEnvio.quote': 'Cotizar Envío',
  'cotizadorEnvio.results': 'Opciones De Envío',
  'cotizadorEnvio.carrier': 'Paquetería',
  'cotizadorEnvio.service': 'Servicio',
  'cotizadorEnvio.days': 'Días',
  'cotizadorEnvio.price': 'Precio',
  'cotizadorEnvio.cheapest': 'La Más Barata',
  'cotizadorEnvio.weightQuoted': 'Se cotizó un bulto de {{kg}} kg',
  'cotizadorEnvio.charge.title': 'Lo Que Pagaría El Cliente',
  'cotizadorEnvio.charge.merchandise': 'Compra',
  'cotizadorEnvio.charge.customerPays': 'Envío al cliente',
  'cotizadorEnvio.charge.free': 'Gratis',
  'cotizadorEnvio.charge.freeFrom': 'Con {{desde}} o más de compra, el envío entra en el beneficio.',
  'cotizadorEnvio.charge.missing': 'Faltan {{monto}} de compra para llegar a los {{desde}} del envío gratis.',
  'cotizadorEnvio.charge.unknown': '{{n}} renglón(es) no están en el catálogo del servidor: no suman al monto de la compra, así que lo de arriba se queda corto.',
  'cotizadorEnvio.casa.title': 'Números De La Casa',
  'cotizadorEnvio.casa.cost': 'Costo de la guía',
  'cotizadorEnvio.casa.absorbs': 'Lo que absorbe la casa',
  'cotizadorEnvio.casa.cap': 'Tope que puede absorber',
  'cotizadorEnvio.casa.overCap': 'Este envío se pasa {{monto}} del tope de la casa.',
  'cotizadorEnvio.casa.autoYes': 'La guía se compraría sola: queda debajo del tope de {{tope}}.',
  'cotizadorEnvio.casa.autoNo': 'La guía NO se compra sola: pasa del tope de {{tope}} y necesita tu visto bueno.',
  'cotizadorEnvio.casa.savings': 'Por comparar entre proveedores se ahorran {{monto}}.',
  'cotizadorEnvio.history': 'Últimas Consultas',
  'cotizadorEnvio.historyEmpty': 'Aquí van quedando las últimas cotizaciones que hagas.',
  'cotizadorEnvio.error': 'No se pudo cotizar. Intenta de nuevo en un minuto.',

  'admin.title': 'Panel De Administración',
  'admin.subtitle': 'Gestiona productos, inventario y pedidos de Exygen Labs',
  'admin.stats.revenue': 'Cobrado',
  // ⛔ "Ingresos" decía que habías cobrado lo que no cobraste: sumaba todo lo
  // entregado. Ahora son dos cifras, y por eso la primera se llama COBRADO.
  'admin.stats.receivable': 'Por cobrar',
  'admin.funnel.noOrder': '+{{monto}} de compras cuyo pedido ya se borró',
  'admin.stats.orders': 'Pedidos',
  'admin.stats.pending': 'Pendientes',
  'admin.stats.products': 'Productos',
  'admin.stats.customers': 'Clientes',
  'admin.productsTab': 'Productos',
  'admin.ordersTab': 'Pedidos',
  'admin.productsCount': '{{count}} productos',
  'admin.products.search': 'Buscar por nombre, categoría, SKU o lote…',
  'admin.newProduct': 'Nuevo producto',
  'admin.table.name': 'Nombre',
  'admin.table.category': 'Categoría',
  'admin.table.purity': 'Pureza',
  'admin.table.stock': 'Stock',
  'admin.table.price': 'Precio',
  'admin.table.batch': 'Lote',
  'admin.featured': 'Destacado',
  'admin.table.order': 'Pedido',
  'admin.table.customer': 'Cliente',
  'admin.table.payment': 'Método',
  'admin.table.paid': 'Pago',
  'admin.pay.paid': 'Pagado',
  'admin.pay.unpaid': 'Sin pagar',
  'admin.pay.markPaid': 'Marcar como pagado',
  'admin.pay.markUnpaid': 'Marcar como NO pagado',
  'admin.table.date': 'Fecha',
  'admin.table.status': 'Estado',
  'admin.noOrders': 'Sin pedidos aun',
  'admin.editProduct': 'Editar producto',
  'admin.select': 'Selecciona',
  'admin.nameRequired': 'Nombre *',
  'admin.categoryRequired': 'Categoría *',
  'admin.presentation': 'Presentación',
  'admin.priceRequired': 'Precio (MXN) *',
  'admin.stock': 'Stock',
  'admin.batchNumber': 'Número de lote',
  'admin.imageUrl': 'URL de imagen',
  'admin.shortDescription': 'Descripción corta',
  'admin.fullDescription': 'Descripción completa',
  'admin.confirmDelete': 'Eliminar "{{name}}"?',
  'admin.toast.required': 'Nombre, categoría y precio son obligatorios',
  'admin.toast.updated': 'Producto actualizado',
  'admin.toast.created': 'Producto creado',
  'admin.toast.saveError': 'Error al guardar',
  'admin.toast.deleted': 'Producto eliminado',
  'admin.toast.deleteError': 'Error al eliminar',
  'admin.toast.statusUpdated': 'Estado actualizado',
  'admin.toast.markedPaid': 'Pedido marcado como pagado',
  'admin.toast.markedUnpaid': 'Pedido marcado como NO pagado',
  'admin.toast.statusError': 'Error al actualizar',
  'admin.salesTab': 'Ventas',
  'admin.funnelTab': 'Embudo',
  'admin.funnel.title': 'Embudo de venta',
  'admin.funnel.sub': 'De cada 100 que llegan, cuántos compran — y de dónde vienen.',
  'admin.funnel.days': 'Últimos {{n}} días',
  'admin.funnel.empty': 'Todavía no hay visitas registradas. La medición empieza a contar desde ahora: en unas horas verás aquí cuánta gente llega y dónde se está cayendo.',
  'admin.funnel.visits': 'Visitas',
  'admin.funnel.conversion': 'Conversión',
  'admin.funnel.revenue': 'Ingreso',
  'admin.funnel.purchases': 'Compras',
  'admin.funnel.stepsTitle': 'Dónde se cae la gente',
  'admin.funnel.stepsSub': 'Cada barra es cuántas personas llegaron a ese paso. El % rojo es cuántas se perdieron respecto al paso anterior.',
  'admin.funnel.sourcesTitle': 'De dónde viene tu tráfico',
  'admin.funnel.sourcesSub': 'Aquí ves si tu publicidad trae gente y si esa gente compra.',
  'admin.funnel.source': 'Origen',
  'admin.funnel.noSources': 'Sin datos de origen todavía.',
  'admin.funnel.topViewed': 'Productos más vistos',
  'admin.customersTab': 'Clientes',
  'admin.customersCount': '{{count}} clientes',
  'admin.table.phone': 'Teléfono',
  'admin.table.ordersCount': 'Pedidos',
  // Ya no es "todo lo que compró": es lo que de verdad PAGÓ. Lo que debe va en su
  // propia columna (`admin.stats.receivable`).
  'admin.table.totalSpent': 'Total pagado',
  'admin.table.lastOrder': 'Ultima compra',
  'admin.table.registered': 'Registro',
  'admin.noCustomers': 'Sin clientes aun',
  'admin.customer.since': 'Cliente desde {{date}}',
  'admin.customer.phones': 'Telefonos',
  'admin.customer.addresses': 'Direcciones de envío',
  'admin.customer.orders': 'Historial de pedidos',
  'admin.customer.noOrders': 'Sin pedidos',

  // LA FICHA DEL CLIENTE — la misma desde cualquier lista (Christián, 2026-07-30).
  'ficha.title': 'Ficha Del Cliente',
  'ficha.open': 'Abrir Ficha Del Cliente',
  'ficha.forbidden': 'Ese cliente no es tuyo.',
  'ficha.notFound': 'No encontramos a esa persona.',
  'ficha.error': 'No se pudo abrir la ficha.',
  'ficha.blocked': 'Cuenta Bloqueada',
  'ficha.referredBy': 'Referido De',
  'ficha.myEarnings': 'Mi Comisión',
  'ficha.ordersWithMe': 'Sus Pedidos Contigo',
  // TODO EL QUE COMPRA ES CLIENTE, tenga cuenta o no (Christián, 2026-07-31).
  'ficha.account': 'Con Cuenta',
  'ficha.firstOrder': 'Primera Compra',
  'ficha.topProducts': 'Lo Que Suele Llevar',
  'ficha.units': '{{units}} pzas · {{orders}} pedidos',
  'admin.customers.search': 'Buscar por nombre, correo o teléfono',
  'admin.customers.noMatch': 'Nadie coincide con esa búsqueda.',
  'admin.customers.guestHint': 'Compró sin abrir cuenta. Su ficha vive en sus pedidos.',
  'admin.customers.duplicateOf': 'Posible duplicado de {{name}}',
  'admin.customers.showing': '{{shown}} de {{count}} clientes',
  'news.openOrder': 'Ver El Pedido',
  'news.openClient': 'Ver Al Cliente',

  // LA HOJA DE LA GUÍA — una sola, desde donde se vea un pedido.
  'guia.add': 'Poner Guía',
  'guia.edit': 'Cambiar Guía',
  'guia.title': 'Guía Del Pedido',
  'guia.number': 'Número De Guía',
  'guia.numberPlaceholder': 'Pega o teclea el número',
  'guia.carrier': 'Paquetería',
  'guia.carrierPlaceholder': 'Elige la paquetería',
  'guia.detected': 'Se ve como {{carrier}} — ya la pusimos.',
  'guia.detectedMaybe': 'Parece {{carrier}}. Confírmala abajo si no lo es.',
  'guia.url': 'Liga De Rastreo (Opcional)',
  'guia.autoUrl': 'Si la dejas vacía, la liga se arma sola con la paquetería y el número.',
  'guia.eta': 'Tiempo Estimado',
  'guia.etaPlaceholder': '3-5 días hábiles',
  'guia.mailNote': 'Al guardar, el cliente recibe su número de guía por correo.',
  'guia.save': 'Guardar Guía',
  'guia.done': 'Listo',
  'guia.saved': 'Guía guardada. El cliente ya recibió el aviso.',
  'guia.error': 'No se pudo guardar la guía.',
  'guia.needNumber': 'Escribe el número de guía.',
  'guia.needCarrier': 'Elige la paquetería.',
  // SOLICITUD DE GUÍA (Christián, 2026-08-03): el distribuidor pide que la casa
  // compre la guía de un pedido YA PAGADO y sin número; el admin aprueba (y se
  // compra con dinero de la casa, por eso el confirm) o rechaza con motivo.
  'guia.solicitud.boton': 'Solicitar Guía',
  'guia.solicitud.etiqueta': 'Guía Solicitada',
  'guia.solicitud.enviada': 'Listo. La casa recibió tu solicitud de guía.',
  'guia.solicitud.error': 'No se pudo. Intenta de nuevo.',
  'guia.solicitud.tituloAdmin': 'Solicitudes De Guía',
  'guia.solicitud.pendientes': '{{n}} Pendientes',
  'guia.solicitud.aprobar': 'Aprobar Y Comprar Guía',
  'guia.solicitud.confirmar': 'Vas a comprar la guía del pedido {{order}} con dinero de la casa. ¿Seguro?',
  'guia.solicitud.aprobada': 'Guía comprada: {{tracking}}. El pedido ya la trae puesta.',
  'guia.solicitud.yaTenia': 'Ese pedido ya tenía guía: {{tracking}}. La solicitud quedó cerrada.',
  'guia.solicitud.rechazar': 'Rechazar',
  'guia.solicitud.motivoRechazo': 'Motivo del rechazo (opcional, el distribuidor lo va a leer):',
  'guia.solicitud.rechazada': 'Solicitud rechazada.',
  // IMPRIMIR LA GUÍA desde el panel, sin salir a la página de la paquetería
  // (Christián, 2026-07-31: «quiero manejar TODO desde nuestra app»).
  'etiqueta.print': 'Imprimir Guía',
  'etiqueta.generating': 'Generando…',
  'etiqueta.open': 'Abrir PDF',
  'etiqueta.opened': 'La guía se abrió en otra pestaña: desde ahí puedes imprimirla o guardarla.',
  'etiqueta.notReady': 'La paquetería todavía está preparando el PDF. Inténtalo en unos segundos.',
  'etiqueta.error': 'No se pudo traer la guía.',
  'admin.order.basuraBadge': 'Datos De Broma',
  'resenas.title': 'Lo Que Dicen Nuestros Clientes',
  'resenas.summary': '{promedio} de 5 estrellas · {n} reseñas en Google',
  'resenas.verEnGoogle': 'Ver en Google',
  'admin.usuariosPrueba.sweep': 'Barrer Usuarios De Prueba',
  'admin.usuariosPrueba.sweepTitle': 'Usuarios De Prueba',
  'admin.usuariosPrueba.sweepBody': 'Se van a borrar {n} cuenta(s) de prueba. No tienen ningún pedido.',
  'admin.usuariosPrueba.none': 'No hay cuentas de prueba que borrar.',
  'admin.usuariosPrueba.ninguno': 'No hay cuentas de prueba: todo limpio.',
  'admin.usuariosPrueba.protected': 'Estas {n} NO se tocan:',
  'admin.usuariosPrueba.confirm': 'Borrar {n}',
  'admin.usuariosPrueba.done': 'Listo: {n} cuenta(s) de prueba borradas.',
  'etiqueta.manual': 'Esa guía se capturó a mano: no hay PDF nuestro que imprimir. Búscalo donde se compró la guía.',
  'envio.etapa.sin_guia': 'Sin guía todavía',
  'envio.etapa.guia_generada': 'Guía Generada · Sin Enviar',
  'envio.etapa.enviado': 'Enviado',
  'envio.etapa.entregado': 'Entregado',
  'envio.marcarEnviado': 'Ya Lo Envié',
  'admin.sales.noData': 'Aun no hay ventas que graficar',
  'admin.sales.avgTicket': 'Ticket promedio',
  'admin.sales.monthly': 'Ingresos por mes',
  'admin.sales.topProducts': 'Top productos por ingresos',
  'admin.sales.byPayment': 'Ingresos por método de pago',
  'admin.sales.units': '{{count}} uds',

  'payment.mercado_pago.label': 'Mercado Pago',
  'payment.mercado_pago.desc': 'Tarjetas, saldo y meses sin intereses',
  'payment.oxxo.label': 'Efectivo en OXXO',
  'payment.oxxo.desc': 'Genera tu ficha y paga en cualquier OXXO',
  'payment.tarjeta.label': 'Tarjeta de crédito / débito',
  'payment.tarjeta.desc': 'Visa, Mastercard, American Express',
  'payment.spei.label': 'Transferencia SPEI',
  'payment.spei.desc': 'Transferencia bancaria interbancaria',
  'payment.cripto.label': 'Criptomoneda',
  'payment.directa.label': 'Venta directa',
  'payment.efectivo.label': 'Efectivo',
  'payment.transferencia.label': 'Transferencia',
  'payment.cripto.desc': 'Bitcoin y otras — pago sin intermediarios',
  'payment.contra_entrega.label': 'Pago contra entrega',
  'payment.contra_entrega.desc': 'Paga al recibir tu pedido',
  'status.pendiente': 'Pendiente',
  'status.confirmado': 'Confirmado',
  'status.enviado': 'Enviado',
  'status.entregado': 'Entregado',
  'status.cancelado': 'Cancelado',

  // ---- Archivo de reportes semanales de publicidad (Admin → Marketing) ----
  'admin.reportes.title': 'Reporte De Publicidad De La Semana',
  'admin.reportes.loading': 'Cargando el archivo de reportes…',
  'admin.reportes.error': 'No se pudo cargar el archivo de reportes.',
  'admin.reportes.empty': 'Todavía no hay ningún reporte archivado. El primero se deposita solo cuando corra el reporte de la semana.',
  'admin.reportes.readText': 'Leer El Reporte Escrito',
  'admin.reportes.download': 'Descargar Video',
  'admin.reportes.downloadText': 'Descargar El Texto',
  'admin.reportes.errorTexto': 'No se pudo abrir el reporte escrito de esa semana.',
  'admin.reportes.watch': 'Ver',
  'admin.reportes.noVideo': 'Esta semana quedó archivada con sus cifras, pero sin video.',
  'admin.reportes.noVideoShort': 'sin video',
  'admin.reportes.trendTitle': 'Cómo Va Semana Con Semana',
  'admin.reportes.trendSub': 'Lo que de verdad sirve del archivo: aunque nunca abras un video, aquí se ve si el gasto trae más conversaciones o menos, y a qué precio.',
  'admin.reportes.waShort': 'Conversaciones de WhatsApp',
  'admin.reportes.spendShort': 'Gasto (USD)',
  'admin.reportes.cpcShort': 'Costo por conversación (USD)',
  'admin.reportes.tableTitle': 'Las Cifras De Cada Semana',
  'admin.reportes.tableSub': 'De la más nueva a la más vieja. Una raya quiere decir que esa semana no se midió — no que haya salido en cero.',
  'admin.reportes.colWeek': 'Semana',
  'admin.reportes.colSpend': 'Gasto',
  'admin.reportes.colClicks': 'Clics',
  'admin.reportes.colWa': 'Conv. WhatsApp',
  'admin.reportes.colCostWa': '$/conversación',
  'admin.reportes.colAttrib': 'Compras de Meta',
  'admin.reportes.colVisits': 'Visitas',
  'admin.reportes.colOrders': 'Compras del sitio',
  'admin.reportes.archiveTitle': 'Semanas Anteriores',
  'admin.reportes.archiveSub': 'De la más nueva a la más vieja. Se ven aquí mismo, sin salir de la página.',
  'admin.reportes.storageTitle': 'Dónde Se Guardan Y Cuánto Ocupan',
  'admin.reportes.storageLine': 'Los videos viven en el disco del servidor, fuera del código: {{semanas}} semanas archivadas, {{ocupa}} en total, y a este ritmo unos {{anual}} al año. Hoy se conservan {{retencion}} semanas. Nada se borra solo: cuando algo se pase de esa raya, aquí sale el aviso y tú decides.',
  'admin.reportes.expiring': '{{n}} semana(s) ya pasaron la retención que fijaste y siguen guardadas, esperando tu decisión:',
};

export default esMX;
